console.log('js/search_hero.js -> v0.2.0');

$(function () {
	const langToId = {
		"fr": { id: 48, lang: "fr" },
		"en": { id: 41, lang: "en" },
		"de": { id: 52, lang: "de" },
		"es": { id: 149, lang: "es" },
		"nl": { id: 39, lang: "nl" },
		"pl": { id: 127, lang: "pl" },
	}

	let idToLang = {};

	for (let key in langToId) {
		idToLang[langToId[key].id] = langToId[key];
	}

	let arrivalMonth = document.querySelectorAll('.landing-search__accordion-item a');
	let viewAllElm = document.querySelector('.sector-view-all');

	// Highlighting function for categories search
	function escapeRegExp(str) {
		return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	function highlightCategoriesMatches(searchTerm) {
		const links = document.querySelectorAll('#search__modal-categories .search__autocomplete a');
		
		const words = searchTerm
			.trim()
			.split(/\s+/)
			.filter(w => w.length)
			.map(escapeRegExp);

		// if nothing to highlight, restore originals
		if (words.length === 0) {
			links.forEach(link => {
				const original = link.getAttribute('data-original-text') || link.textContent;
				link.removeAttribute('data-original-text');
				link.innerHTML = original;
			});
			return;
		}

		const regex = new RegExp(`(${words.join('|')})`, 'gi');

		links.forEach(link => {
			// stash the plain text once
			const original = link.getAttribute('data-original-text') || link.textContent;
			link.setAttribute('data-original-text', original);

			// do a single replace on the **plain** text
			const highlighted = original.replace(regex, '<span style="font-weight:bold">$1</span>');
			link.innerHTML = highlighted;
		});
	}
	let viewAllElmMbls = document.querySelectorAll('.sector-view-all.sector-view-all-mobile');
	let viewAllUrl = '';

	if (!!viewAllElmMbls.length) {
		viewAllElmMbls.forEach(el => {
			el.addEventListener('click', (ev) => {
				el.dataset.href ? window.location.href = el.dataset.href : null;
			});
		})
	}

	if (arrivalMonth.length > 0 && !!viewAllElm) {
		viewAllUrl = viewAllElm.getAttribute('href') ? viewAllElm.getAttribute('href') : viewAllElm.dataset.href;

        arrivalMonth.forEach(elm => {
            let url = elm.getAttribute('href');
            let date = url.split('?')[1];
            let newUrl = ''
            let sep = (viewAllUrl.indexOf('?') !== -1) ? '&' : '?';
            newUrl = `${viewAllUrl}${sep}${date}`;
            if ($('.landing-search').attr('id') === 'new-landing-search') {
                elm.addEventListener('click', function(ev){
                    ev.preventDefault();
                    try { gae('search_hero', 'tp_modal_arrival-link'); } catch(e) {}
                    console.log('🎯 [ARRIVAL MONTH CLICK] would redirect to:', newUrl);
                    
                    window.__expSrParamDateQuery = date;
                    
                    var monthText = elm.textContent.trim();
                    $('.js-desktop-search-input-arrival').val(monthText);
                    
                    $('#search__modal-arrival').addClass('hide');
                });
            } else {
                elm.setAttribute('href', newUrl);
            }
        });

        // Experiment: prevent redirect on date clicks inside #availability-options and log URL if present
        if ($('.landing-search').attr('id') === 'new-landing-search') {
            // Anchor clicks inside availability calendar
            $('#availability-options').on('click', 'a', function(ev){
                ev.preventDefault();
                ev.stopPropagation();
                var href = $(this).attr('href');
                if (href) {
                    console.log('🎯 [ARRIVAL DATE CLICK] would redirect to:', href);
                    
                    var dateQuery = href.split('?')[1];
                    if (dateQuery) {
                        window.__expSrParamDateQuery = dateQuery;
                        
                        var urlParams = new URLSearchParams('?' + dateQuery);
                        var arrivalDate = urlParams.get('arrival_date');
                        var flexible = urlParams.get('flexible');
                        
                        if (arrivalDate) {
                            var dateObj = new Date(arrivalDate);
                            var options = { year: 'numeric', month: 'long', day: 'numeric' };
                            var formattedDate = dateObj.toLocaleDateString('en-US', options);
                            if (flexible && flexible !== '0') {
                                formattedDate += ' (±' + flexible + ' days)';
                            }
                            $('.js-desktop-search-input-arrival').val(formattedDate);
                        }
                        
                        $('#search__modal-arrival').addClass('hide');
                    }
                } else {
                    console.log('🎯 [ARRIVAL DATE CLICK] suppressed (no href)');
                }
            });
            // Fallback for non-anchor clicks that could bubble to navigation
            $('#availability-options').on('click', function(ev){
                // if click was on an anchor, handled above
                if (ev.target && ev.target.closest && ev.target.closest('a')) return;
                ev.preventDefault();
                ev.stopPropagation();
                console.log('🎯 [ARRIVAL DATE CLICK] suppressed');
            });
        }
	}

	// mobile
	if ($(window).width() < 768) {
		var DestinationSearchInput = $('.js-mobile-search-input-destination'),
			ActivitySearchInput = $('.js-mobile-search-input-activity'),
			tpClearerSearchDropdown = $('.tp_clearer_search_dropdown'),
			CompoundSearchInput = $('.js-mobile-search-input-compoundsearch'),
			StyleSearchInput = $('.js-mobile-search-input-style'); //search_hero_js_surf

	$('.js-search__modal-toggle').on('click touch', function () {
		var modalId = $(this).attr('data-modal');
		var isCategoryInput = $(this).hasClass('js-desktop-search-input-categories') || $(this).hasClass('js-mobile-search-input-categories');
		var isExperiment = $('.landing-search').attr('id') === 'new-landing-search';
		
		console.log('🎯 [GLOBAL MOBILE HANDLER] Clicked element:', {
			modalId: modalId,
			isCategoryInput: isCategoryInput,
			isExperiment: isExperiment,
			modalHidden: $('#search__modal-' + modalId).hasClass('hide'),
			classes: $(this).attr('class')
		});
		
		// Skip entirely if experiment is active (let experiment handler manage all modals)
		if (isExperiment) {
			console.log('🎯 [GLOBAL MOBILE HANDLER] Skipping for experiment, letting experiment handler manage');
			return;
		}
		
		$('body').attr('data-pos', $(window).scrollTop());
		$('body,html').addClass('noscroll');
		$('input').blur();
		$('#search__modal-' + modalId).removeClass('hide');
		$('#search__modal-' + modalId).find('input').focus();
		return false;
	});

	}
	else { // desktop
		var currentOpenModal = null;

		var DestinationSearchInput = $('.js-desktop-search-input-destination'),
			ActivitySearchInput = $('.js-desktop-search-input-activity'),
			ArrivalSearchInput = $('.js-desktop-search-input-arrival'),
			tpClearerSearchDropdown = $('.tp_clearer_search_dropdown'),
			CompoundSearchInput = $('#search-bar-input')?.hasClass('plt-new-search')
				? $('#search-bar-input')
				: $('.js-desktop-search-input-compoundsearch'),
			StyleSearchInput = $('.js-desktop-search-input-style'); //search_hero_js_surf


	$('.js-search__modal-toggle').on('click', function () {
		var modalId = $(this).attr('data-modal');
		var isCategoryInput = $(this).hasClass('js-desktop-search-input-categories') || $(this).hasClass('js-mobile-search-input-categories');
		var isExperiment = $('.landing-search').attr('id') === 'new-landing-search';
		
		console.log('🎯 [GLOBAL HANDLER] Clicked element:', {
			modalId: modalId,
			isCategoryInput: isCategoryInput,
			isExperiment: isExperiment,
			classes: $(this).attr('class')
		});
		
		// Skip if this is a category input in the experiment (handled by experiment handler)
		if (isCategoryInput && isExperiment) {
			console.log('🎯 [GLOBAL HANDLER] Skipping for experiment category input');
			return false; // Let the experiment handler manage category modal
		}
		
		var $modal = $('#search__modal-' + modalId);

		$('#search__modal-compoundsearch').addClass('hide');

			if (currentOpenModal === modalId) {
				$modal.addClass('hide');
				currentOpenModal = null;
			} else {
				$('.js-search__modal').addClass('hide');
				$modal.removeClass('hide');
				// Experiment: track modal open events
				if ($('.landing-search').attr('id') === 'new-landing-search') {
					var evt = null;
					if (modalId === 'arrival') { evt = 'tp_modal_arrival-open'; }
					else if (modalId === 'categories' || modalId === 'activity') { evt = 'tp_modal_activity-open'; }
					else if (modalId === 'compoundsearch' || modalId === 'destination') { evt = 'tp_modal_destination-open'; }
					if (evt) { try { gae('search_hero', evt); } catch(e) {} }
				}
				currentOpenModal = modalId;
			}

			return false;
		});

		$(document).on('click', function (e) {
			if (!$(e.target).closest('.js-search__modal, .js-search__modal-toggle').length) {
				$('.js-search__modal').addClass('hide');
				currentOpenModal = null;
			}
		});

		// Hides the modal when clicking outside
		$('body').on('click touch', function (e) {
			if (e.target.classList.contains('landing-filter_flexible') || e.target.classList.contains('landing-search__accordion-toggle')) {
				return;
			}
			if ($(e.target).parents('.search__wrapper').length == 0) {
				$('.js-search__modal').addClass('hide');
				$('.js-search__modal-toggle').blur();
			}
		});

		// Scrolls top to show result
		DestinationSearchInput.keyup(function (e) {
			if (e.keyCode != 13) { DestinationSearchInput.parent('.search__input-wrapper').find('.search__modal-wrapper').scrollTop(0); }
		});

		// Prevents type on arrival input field
		ArrivalSearchInput.keypress(function (e) {
			e.preventDefault();
			return false
		});

	}

	var pagetype = 'tp';
	if (isIndexPage) {
		pagetype = 'ip'
	};

	$('.js-search__close,.search__modal-backdrop').on('click touch', function () {
		var $modal = $(this).closest('.search__modal');
		console.log('🎯 [CLOSE MODAL] Closing modal:', {
			modalId: $modal.attr('id'),
			hasHideClass: $modal.hasClass('hide'),
			inlineStyle: $modal.attr('style')
		});
		$('.search__modal-header input').val('').trigger('keyup');
		$('body,html').removeClass('noscroll');
		$modal.addClass('hide');
		$(window).scrollTop($('body').attr('data-pos'));
		console.log('🎯 [CLOSE MODAL] After close:', {
			hasHideClass: $modal.hasClass('hide'),
			inlineStyle: $modal.attr('style')
		});
		gae('search_hero', pagetype + '_modal_' + $(this).closest('[data-type]').attr('data-type') + '-close');
	});

	// get destinations when you expand a country list
	$('.search__accordion-toggle').on('click touch', function () {
		$(this).toggleClass('active').closest('li').next('ul').toggleClass('active');
		var li = $(this).closest('li');

		if (!$(li).hasClass('expanded') && $(li).attr('data-id')) {
			var id = $(this).closest('li').attr('data-id');

			var path = $(location).attr("pathname");

			if (path.indexOf("/all/") >= 0)
				path = path.replace('/all/', '/subdestinations/');
			else
				path = '/subdestinations/';

			var url = $(location).attr("href");

			if (url.indexOf('?') >= 0)
				path += url.substring(url.indexOf('?'), url.length) + "&did=" + id;
			else
				path += "?did=" + id;

			$.ajax({
				type: "GET",
				url: path,
				async: true,
				li: li
			}).done(function (result) {
				var url = $(this.li).find('a:first-of-type').attr('href');
				$(this.li).addClass('expanded');
				var el = $('<ul class="search__accordion search__accordion-lvl3 active"></ul>');
				for (i = 0; i < result.destinations.length; i++) {
					var href = result.destinations[i].url.split('/');
					href = href.slice(0, href.length - 1).join('/');
					var subUrl = url.replace(href, result.destinations[i].url);
					$(el).append('<li><a href="' + subUrl + '">' + result.destinations[i].name + '</a></li>');
				};
				$(el).insertAfter($(this.li));
			});
		};
		gae('search_hero', pagetype + '_modal_accordion-toggle');
	});

	$('.search__accordion-toggle').each(function () {
		$(this).parent().find('p').on('click touch', function () {
			$(this).parent().find('.search__accordion-toggle').trigger('click');
		});
	});

	DestinationSearchInput.keyup(function (e) {
		var code = e.keyCode || e.which;
		var val = $(this).val();
		if (code == 13 && !$('#search__modal-destination .search__autocomplete').hasClass('hide')) {
			var url = $('#search__modal-destination .search__autocomplete a').first().attr('href');
			gae('search_hero', pagetype + '_modal-destination-enter--' + val);
			if (url && url.length > 0) {
				window.location.href = url;
			};
		} else {
			var elem = $(this);
			if (val.length > 0) {
				clearTimeout(window.smdqt);
				window.smdqt = setTimeout(function () {
					gae('search_hero', pagetype + '_modal-destination-query--' + val);
				}, 600);
				$('#search__modal-destination .search__autocomplete').removeClass('hide');
				$('#search__modal-destination .search__autocomplete-noresults').addClass('hide');

				var selectedCategoriesQuery = '';
				if (siteid == 4 && typeof (selectedCategories) != 'undefined') {
					selectedCategoriesQuery = '&selectedCategories=' + selectedCategories.join(',');
				};

				var xhr = new XMLHttpRequest();
				var prefix = selectedLanguage == 'en' ? '' : '/' + selectedLanguage;
				const tpSearchResultsParam = (isSearchResultsPage ? "&tpsr" : "");
				xhr.open('GET', `${prefix}/test-dest-search?dest_id=${destinationID}&query=${encodeURI(val)}${selectedCategoriesQuery}${tpSearchResultsParam}`);
				xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				xhr.send(null);
				xhr.onreadystatechange = function () {
					if ($(elem).val() != val) {
						return;
					};
					if (xhr.readyState === 4) {
						$('#search__modal-destination .search__autocomplete ul').remove();

						var res = $("<ul class='search__accordion search__accordion-lvl2 active' style='margin-top: -10px;'></ul>");

						if (xhr.status === 200) {
							var data = JSON.parse(xhr.responseText);
							var seen = {}
							var total = 0;

							if (data.hits.hits.length > 0) {
								for (var i = 0; i < data.hits.hits.length; i++) {

									var hit = data.hits.hits[i]._source;

									if (seen[hit.destination_id]) {
										continue;
									};

									seen[hit.destination_id] = true;

									var name = hit.name;

									if (hit.country) {
										name += ', ' + hit.country;
									};

									var n = hit["listings_" + siteid];

									if (n > 0) {
										name += ' (' + n + ')';
									};

									var lang = langToId[selectedLanguage] || langToId["en"];
									var path = hit.paths[lang.id];

									if (siteid == 4) {
										path = hit.path;
									};

									var afterUrl = removeQueryStringParameter("?" + decodeURIComponent(window.location.search.substring(1)), "page");

									if (siteid != 4 && !isSearchResultsPage && (isIndexPage || isTopicPage)) {
										if (afterUrl.indexOf('show_all') == -1) {
											if (afterUrl.indexOf('?') > -1) {
												afterUrl += '&show_all';
											} else {
												afterUrl += '?show_all';
											};
										}
									}

									afterUrl = afterUrl.replace("?&", "?");

									var beforeUrl = decodeURIComponent(window.location);
									if (beforeUrl.indexOf('?') > 0) { beforeUrl = location.href.substring(0, location.href.indexOf('?')); }
									if (typeof (filteredOnDestination) != 'undefined') { beforeUrl = location.href.substring(0, location.href.indexOf('/d/')); }

									if (siteid == 4) {
										const destSlug = hit.slug;

										if (isSearchResultsPage) {
											let queryParams = new URLSearchParams(afterUrl);
											queryParams.set('d', destSlug);
											afterUrl = `?${queryParams.toString()}`;
										}

										const href = `${path}${afterUrl}`;
										$(res).append(`<li class='search__accordion-item search__accordion-item-lvl2'><a href='${href}'>${name}</a></li>`);
									} else {
										let bscClass = siteid == 7 ? 'bsc-destination-item' : '';
										if (isSearchResultsPage) {
											$(res).append(`<li class='search__accordion-item search__accordion-item-lvl2'><a class="${bscClass}" href='${hit.query_url}'>${name}</a></li>`);
										} else if (isIndexPage == true) {
											$(res).append(`<li class='search__accordion-item search__accordion-item-lvl2'><a class="${bscClass}" href='/` + lang.lang + "/all/d/" + path + afterUrl + "'>" + name + "</a></li>");
										} else {
											$(res).append(`<li class='search__accordion-item search__accordion-item-lvl2'><a class="${bscClass}" href='` + beforeUrl + "/d/" + path + afterUrl + "'>" + name + "</a></li>");
										}
									};

									if (total++ >= 4) {
										break;
									};
								};
								$('#search__modal-destination .search__autocomplete').append(res);
							} else {
								$('#search__modal-destination .search__autocomplete-noresults').removeClass('hide');
							}
						} else {
							$('#search__modal-destination .search__autocomplete').addClass('hide');
						};
					};
				};
			} else {
				$('#search__modal-destination .search__autocomplete').addClass('hide');
			};
		}
	});
	// end DestinationSearchInput
	ActivitySearchInput.keyup(function (e) {
		var code = e.keyCode || e.which;
		var val = $(this).val().toLowerCase();
		var target = $('#search__modal-activity');
		if (val.length > 0) {
			clearTimeout(window.smaqt);
			window.smaqt = setTimeout(function () {
				gae('search_hero', pagetype + '_modal-activity-query--' + val);
			}, 600);
			if (code == 13) {
				gae('search_hero', pagetype + '_modal-activity-enter--' + val);
				var url = $(target).find('.search__accordion li:not(.hide) a').first().attr('href');
				if (url && url.length > 0) {
					window.location.href = url;
				};
			} else {
				$(target).find('.search__accordion').each(function () {
					var show = 0;
					$(this).find('li.search__accordion-item-lvl2').each(function () {
						var text = $(this).text().toLowerCase();
						if (text.indexOf(val) > -1 || similarity(text, val) >= 0.75) {
							$(this).removeClass('hide');
							show++;
						} else {
							$(this).addClass('hide');
						};
					});
					if (show > 0) {
						$(this).addClass('active');
						$(this).find('.search__accordion-toggle').addClass('active');
						$(this).removeClass('hide');
					} else {
						$(this).removeClass('active');
						$(this).find('.search__accordion-toggle').removeClass('active');
						$(this).addClass('hide');
					};
				});
			};
		} else {
			$(target).find('.search__accordion').removeClass('active').removeClass('hide').find('li').removeClass('hide');
		};

	});
	// end ActivitySearchInput
	// search_hero_js_surf START
	StyleSearchInput.keyup(function (e) {
		var code = e.keyCode || e.which;
		var val = $(this).val().toLowerCase();
		var target = $('#search__modal-style');
		if (val.length > 0) {
			clearTimeout(window.smaqt);
			window.smaqt = setTimeout(function () {
				gae('search_hero', pagetype + '_modal-style-query--' + val);
			}, 600);
			if (code == 13) {
				var url = $(target).find('.search__accordion li:not(.hide) a').first().attr('href');
				if (url && url.length > 0) {
					window.location.href = url;
				};
			} else {
				$(target).find('.search__accordion').each(function () {
					var show = 0;
					$(this).find('li.search__accordion-item-lvl2').each(function () {
						var text = $(this).text().toLowerCase();
						if (text.indexOf(val) > -1 || similarity(text, val) >= 0.75) {
							$(this).removeClass('hide');
							show++;
						} else {
							$(this).addClass('hide');
						};
					});
					if (show > 0) {
						$(this).addClass('active');
						$(this).find('.search__accordion-toggle').addClass('active');
						$(this).removeClass('hide');
					} else {
						$(this).removeClass('active');
						$(this).find('.search__accordion-toggle').removeClass('active');
						$(this).addClass('hide');
					};
				});
			};
		} else {
			$(target).find('.search__accordion').removeClass('active').removeClass('hide').find('li').removeClass('hide');
		};

	});
	//end StyleSearchInput

	const enterSearchLink = () => {
		var url = $('#compound_search .search-accordion-item a:visible').first().attr('href');
		var type = $('#compound_search .search-accordion-item a:visible').first().closest('[data-type]').attr('data-type');
		var text = $('#compound_search .search-accordion-item a:visible').first().text();

		if (url && url.length > 0) {
			CompoundSearchInput.val(text);
			window.location.href = url;
		}
	};

	// Categories Search Input Handler (desktop + mobile)
	var CategoriesSearchInput = $('.js-desktop-search-input-categories, .js-mobile-search-input-categories');

// Prefill categories input from URL like /all/c/<category>/...
try {
    var pathForCat = window.location.pathname || '';
    var mCat = pathForCat.match(/\/all\/c\/([^\/]+)/);
    if (mCat && mCat[1]) {
        var catName = decodeURIComponent(mCat[1]).replace(/-/g, ' ').trim()
            .split(' ').map(function(w){ return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
        var $catTargets = $('.js-desktop-search-input-categories, .js-mobile-search-input-categories');
        if ($catTargets.length) {
            $catTargets.each(function(){
                if (!$(this).val()) {
                    $(this).val(catName);
                }
            });
        }
    }
} catch(e) {}
	
	// Show default content when modal opens
    CategoriesSearchInput.on('focus', function() {
        var hasVal = !!($(this).val() && $(this).val().trim().length);
        var $results = $('#search__modal-categories .search__autocomplete');
        if (hasVal && $results.length) {
            $('#search__modal-categories .js-search-default').addClass('hide');
            $results.removeClass('hide');
        } else {
            $('#search__modal-categories .js-search-default').removeClass('hide');
            $results.remove();
        }
    });
	
// Ensure input also triggers key handler paths
CategoriesSearchInput.on('input', function(){
    $(this).trigger('keyup');
});

CategoriesSearchInput.keyup(function (e) {
	let code = e.keyCode || e.which;
	var isExperiment = $('.landing-search').attr('id') === 'new-landing-search';
	
	console.log('🎯 [EARLY CAT KEYUP] Handler fired, isExperiment:', isExperiment, 'keyCode:', code, 'value:', $(this).val());
	
	// Skip entire handler if experiment is active (let experiment handler manage it)
	if (isExperiment) {
		console.log('🎯 [EARLY CAT KEYUP] Skipping for experiment, letting experiment handler manage');
		return;
	}

	// when the enter key is pressed
	if (code == 13) {
		gae('search_hero', pagetype + '_modal_categories-enter');
		var url = $('#search__modal-categories .search-accordion-item a:visible').first().attr('href');
		if (url && url.length > 0) {
			CategoriesSearchInput.val($('#search__modal-categories .search-accordion-item a:visible').first().text());
			window.location.href = url;
		}
	}
	// if any other key is pressed
	else {
		
		var val = $(this).val();
		var elem = $(this);
		
		console.log('🎯 [KEYUP CAT] Triggering autocomplete for:', val);

	if (val.length > 0) {
		// Hide default content when user starts typing
		$('#search__modal-categories .js-search-default').addClass('hide');
		
		clearTimeout(window.categories_search_query);
		window.categories_search_query = setTimeout(function () {
			gae('search_hero', pagetype + '_query_categories_' + val);
		}, 600);

			$('#search__modal-categories .search__autocomplete-noresults').addClass('hide');
			$('#search__modal-categories .search__autocomplete-noresults').parent().addClass('hide');

				var prefix = selectedLanguage == 'en' ? '' : '/' + selectedLanguage;
				// Categories search uses the excluded indexes: styles,categories,listings
				// For site ID 4, use Tripaneer-specific indexes
				var indexes;
				if (siteid == '4') {
					indexes = 'styles,tripaneer_categories,listings';
				} else {
					indexes = 'styles,categories,listings';
				}
				var query = prefix + '/searching?dest_id=' + destinationID + '&index=' + indexes + '&query=' + encodeURI(val);
				var lang = langToId[selectedLanguage] || langToId["en"];

				var xhr = new XMLHttpRequest();
				xhr.open('GET', query);
				xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				xhr.send(null);

				xhr.onreadystatechange = function () {
					// ignore keys while we were waiting for response
					if ($(elem).val() != val) {
						return;
					}

					if (xhr.readyState === 4) {
						$('#search__modal-categories .search__autocomplete-noresults').addClass('hide');
						$('#search__modal-categories .search__autocomplete-noresults').parent().addClass('hide');
						$('#search__modal-categories .js-search-default').removeClass('hide');
						$('#search__modal-categories .search__autocomplete').remove();

						var res = $("<div class='search__autocomplete'></div>");

						if (xhr.status === 200) {
							var data = JSON.parse(xhr.responseText);
							var types;
							// For site ID 4, use Tripaneer-specific types
							if (siteid == '4') {
								types = ['tripaneer_categories', 'styles', 'listings'];
							} else {
								types = ['categories', 'styles', 'listings'];
							}

							var seen = {}
							var total = 0;

							const itemLimit = 4;

							types.forEach((type, t) => {
								if (data[type] && data[type].hits.hits.length > 0) {
									var resGroup = $("<ul class='search__accordion search__accordion-lvl1'></ul>");
									var title = $('[data-transtag-' + type + ']').attr('data-transtag-' + type);

									resGroup.append(`<li class='search__accordion-item search__accordion-item-lvl1'><h4>` + title + ":</h4></li>");
									resGroup.append(`<ul class='search__accordion search__accordion-lvl2 active'></ul>`);

									var resGroupItems = resGroup.find('.search__accordion-lvl2');
									var typeItems = 0;

									for (var i = 0; i < data[type].hits.hits.length; i++) {
										var hit = data[type].hits.hits[i]._source
										var name = hit.name;
										var path = (hit.language && hit.language != 41) ? ('/' + idToLang[hit.language].lang + hit.url) : hit.url;

										if (hit.country) {
											name += ', ' + hit.country
										}

										if (path.indexOf('?') > -1) {
											path += '&q=' + val;
										} else {
											path += '?q=' + val;
									};

									path += "&online_offer=false"

   if ($('.landing-search').attr('id') === 'new-landing-search') {
                                            // Experiment: render non-links with data attributes handled by delegated click
                                            resGroupItems.append(`<li
                                                data-type="${type}"
                                                class='
                                                    search-accordion-item
                                                    search-accordion-item-lvl2
                                                    search-accordion-item--${type}
                                                    ${typeItems > itemLimit ? 'hidden' : ''}
                                                '
                                            >
                                                <div
                                                    class="experiment-category-item"
                                                    data-type="${type}"
                                                    data-sr-param="${path}"
                                                    data-item-name="${name}"
                                                    style="cursor:pointer"
                                                    onclick="console.log('sr_param:', '${path}');$('.js-desktop-search-input-categories').val('${name}');$(this).closest('.search__modal').addClass('hide')"
                                                >${name}</div>
                                            </li>`);
                                        } else {
                                            resGroupItems.append(`<li
                                                data-type="${type}"
                                                class='
                                                    search-accordion-item
                                                    search-accordion-item-lvl2
                                                    search-accordion-item--${type}
                                                    ${typeItems > itemLimit ? 'hidden' : ''}
                                                '
                                                onclick='gae(
                                                    "search_hero",
                                                    "${pagetype}_modal_categories-link"
                                                );'
                                            >
                                                <a href='${path}'>${name}</a>
                                            </li>`);
                                        }

										typeItems++;
										total++;

										if (typeItems > itemLimit) {
											break;
										}
									}

									if (typeItems > 0) {
										res.append(resGroup);
									}
								}
							});

						if (total === 0) {
							console.log('🎯 [CAT AUTOCOMPLETE] No results found');
							$('#search__modal-categories .search__autocomplete-noresults').removeClass('hide');
							$('#search__modal-categories .search__autocomplete-noresults').parent().removeClass('hide');
							$('#search__modal-categories .js-search-default').addClass('hide');
						} else {
							console.log('🎯 [CAT AUTOCOMPLETE] Appending', total, 'results to category modal');
							$('#search__modal-categories .js-search-default').addClass('hide');
							$('#search__modal-categories .js-append-compound-search-results').append(res);
							// Highlight search terms in the results after DOM update
							setTimeout(() => {
								highlightCategoriesMatches(val);
							}, 10);
						}
						}
					}
				}
			} else {
				$('#search__modal-categories .search__autocomplete').remove();
				$('#search__modal-categories .js-search-default').removeClass('hide');
			}
		}
	});

	CompoundSearchInput.keyup(function (e) {
		let code = e.keyCode || e.which;
		
		// Skip this logic if we're in the new landing search experiment
		// The experiment uses search.js instead of this file
		if ($('.landing-search').attr('id') === 'new-landing-search') {
			console.log('🚫 [SEARCH_HERO] Skipping search_hero.js logic for new landing search experiment');
			return;
		}
		
		const searchText = document.querySelector('.search_for_free_text');
		searchText ? searchText.innerHTML = `Search for <b>${e.target.value}</b>` : null;

		const searchList = document.querySelector('.js-append-compound-search-results');
		if (searchList.querySelector('.sch-accrdn-no-matches')) {searchList.querySelector('.sch-accrdn-no-matches').remove();}

		// when the enter key is pressed
		if (code == 13) {
			gae('search_hero', pagetype + '_modal_compoundsearch-enter');
			searchText ? searchText.click() : enterSearchLink();
		}
		// if any other key is pressed
		else {
			var val = $(this).val();
			var elem = $(this);

			if (val.length > 0) {
				clearTimeout(window.full_search_query);
				window.full_search_query = setTimeout(function () {
					gae('search_hero', pagetype + '_query_' + val);
				}, 600);


			var prefix = selectedLanguage == 'en' ? '' : '/' + selectedLanguage;
			let indexes;
			 switch (siteid) {
				case '4':
					// Check if we're in the new landing search experiment
					if ($('.landing-search').attr('id') === 'new-landing-search') {
						indexes = 'destinations,organizers';
					} else {
						indexes = 'destinations,styles,tripaneer_categories,listings,organizers';
					}
					break;
				default:
					indexes = 'destinations,styles,categories,listings,organizers';
			}

				var query = prefix + '/searching?dest_id=' + destinationID + '&index=' + indexes + '&query=' + encodeURI(val);
				var lang = langToId[selectedLanguage] || langToId["en"];


				var xhr = new XMLHttpRequest();
				xhr.open('GET', query);
				xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				xhr.send(null);

				xhr.onreadystatechange = function () {
					// ignore keys while we were waiting for response
					if ($(elem).val() != val) {
						return;
					}

					if (xhr.readyState === 4) {
						$('.js-search-default').removeClass('hide');
						$('#compound_search .search__autocomplete').remove();

						var res = $("<div class='search__autocomplete'></div>");

						if (xhr.status === 200) {
							var data = JSON.parse(xhr.responseText);

			switch (siteid) {
				case '4':
					// Check if we're in the new landing search experiment
					if ($('.landing-search').attr('id') === 'new-landing-search') {
						var types = ['destinations', 'organizers'];
					} else {
						var types = ['destinations', 'tripaneer_categories_with_dest', 'tripaneer_categories', 'styles_with_dest', 'styles', 'listings', 'organizers'];
					}
					break;
				default:
					var types = ['destinations', 'categories_with_dest', 'styles_with_dest', 'categories', 'styles', 'listings', 'organizers'];
			}

							var seen = {}
							var total = 0;

							const itemLimit = 4;
				if (data && data['noMatchMsg']) {
					const noMatches = `<ul class="search__accordion search__accordion-lvl1 sch-accrdn-no-matches">
						<div class="search__autocomplete-noresults modal-autocomplete">
							${data['noMatchMsg']}
						</div>
					</ul>`;
					if (!searchList.querySelector('.sch-accrdn-no-matches')) {
						searchList.insertAdjacentHTML('afterbegin', noMatches);
					}
				} else {
					// Only track listings if we're not in the new landing search experiment
					if (!($('.landing-search').attr('id') === 'new-landing-search') && data['listings'] && data['listings'].hits.total.value > 0) {
						gae('search_hero', pagetype + '_modal_autocomplete_results_listings');
					}

					types.forEach((type, t) => {
						if (data[type] && data[type].hits.hits.length > 0) {
							var resGroup = $("<ul class='search__accordion search__accordion-lvl1'></ul>");
							var title = $('[data-transtag-' + type + ']').attr('data-transtag-' + type);
							var destinationValue = $('[data-transtag-destination_raw]').attr('data-transtag-destination_raw');

							resGroup.append(`<li class='search__accordion-item search__accordion-item-lvl1'><h4>` + title + ":</h4></li>");
							resGroup.append(`<ul class='search__accordion search__accordion-lvl2 active'></ul>`);

							var resGroupItems = resGroup.find('.search__accordion-lvl2');
							var typeItems = 0;
							for (var i = 0; i < data[type].hits.hits.length; i++) {
								var hit = data[type].hits.hits[i]._source
								var name = hit.name;
								var path = (hit.language && hit.language != 41) ? ('/' + idToLang[hit.language].lang + hit.url) : hit.url;

								if (hit.country) {
									name += ', ' + hit.country
								}

								if ((type == "categories_with_dest" || type == "styles_with_dest") && tpClearerSearchDropdown.length > 0) {
									name += ' <span class="with-dest">' + destinationValue + '</span>';
								}

								if (isSearchResultsPage && hit.query_url) {
									path = hit.query_url;
								} else {
									if (type == "destinations") {
										if (+siteid === 4) {
											path = hit.path;
										} else {
											if (typeof (filteredOnActivity) != 'undefined') {
												var beforeUrl = decodeURIComponent(window.location);
												var destinationPosition = beforeUrl.indexOf('/d/');

												if (destinationPosition > 0) { //there is another destination selected
													beforeUrl = beforeUrl.substring(0, destinationPosition);
												}
												if (beforeUrl.indexOf('?') > 0) {
													beforeUrl = location.href.substring(0, location.href.indexOf('?'));
												}
												beforeUrl = removeHost(beforeUrl);
												path = beforeUrl + '/d/' + hit.paths[lang.id];
											} else {
												var langPart = hit.language != 41 ? '/' + idToLang[hit.language].lang : '';
												path = langPart + '/all/d/' + hit.paths[lang.id];
											}
										}
									}
								}

								// changed id to path, due to use of both filter and filter_with_dest
								var id = path;

								if (typeof (hit.destination_id) != 'undefined') {
									var id = hit.destination_id;
								};

								if (seen[id]) continue;
								seen[id] = true;

								if (isIndexPage || isTopicPage) {
									var urls = ['/all/c/budget-retreats', '/all/d/asia-and-oceania/india', '/all/d/europe/united-kingdom'];

									for (j = 0; j < urls.length; j++) {
										if (path == urls[j]) {
											if (path.indexOf('?') > -1) {
												path += '&search';
											} else {
												path += '?search';
											};
										};
									};
								};

								if (path.indexOf('?') > -1) {
									path += '&q=' + val;
								} else {
									path += '?q=' + val;
								};

								if (!isSearchResultsPage && path.indexOf('show_all') == -1) {
									if (isIndexPage || isTopicPage) {
										path += '&show_all';
									}
								}

								path += "&online_offer=false"

							if ($('.landing-search').attr('id') === 'new-landing-search') {
								resGroupItems.append(`<li
									data-type="${type}"
									data-sr-param="${path}"
									data-item-name="${name}"
									class='
										search-accordion-item
										search-accordion-item-lvl2
										search-accordion-item--${type}
										experiment-search-item
										${typeItems > itemLimit ? 'hidden' : ''}
									'
									style="cursor: pointer;"
								>
									${name}
								</li>`);
							} else {
								resGroupItems.append(`<li
									data-type="${type}"
									class='
										search-accordion-item
										search-accordion-item-lvl2
										search-accordion-item--${type}
										${typeItems > itemLimit ? 'hidden' : ''}
									'
									onclick='gae(
										"search_hero",
										"${pagetype}_modal_compoundsearch-link"
									);'
								>
									<a href='${path}' ${siteid == '4' && window.location.pathname === '/' ? 'target="_blank" rel="noopener"' : ''}>${name}</a>
								</li>`);
							}
								typeItems++;
								total++;
							}
							res.append(resGroup);
						}
					});
				}


							/*
							 * Added a check where when the featureFlag (listings in search results) is false, we subtract the listing results from the total
							 * This way we still show the other results, but hide the listings from base, but also, when there are no results, we properly show the no results message
							 * 20230504 - Richard
							 */

							let firstText = $('#compound_search .search-accordion-item a:visible').first().text();

							if (total > 0) {
								$('.js-append-compound-search-results').append(res);
								$('#compound_search .search__autocomplete a').click(function () {
									CompoundSearchInput.val(firstText);
								});
								$('.js-search-default').addClass('hide');
								highlightMatches(val);
							} else {
								$('#compound_search .search__autocomplete').remove();
								$('.js-search-default').removeClass('hide');
							}
						} else {
							$('#compound_search .search__autocomplete').remove();
							$('.js-search-default').removeClass('hide');
						}
					}
				}
			}
			// show the no result
			else {
				$('#compound_search .search__autocomplete').remove();
				$('.js-search-default').removeClass('hide');
			};
		}
	});

	function escapeRegExp(str) {
		return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	// single-pass highlighter on the plain text
	function highlightMatches(searchTerm) {
		const links = document.querySelectorAll('#compound_search .search__autocomplete a');
		const words = searchTerm
			.trim()
			.split(/\s+/)
			.filter(w => w.length)
			.map(escapeRegExp);

		// if nothing to highlight, restore originals
		if (words.length === 0) {
			links.forEach(link => {
				const original = link.getAttribute('data-original-text') || link.textContent;
				link.removeAttribute('data-original-text');
				link.innerHTML = original;
			});
			return;
		}

		const regex = new RegExp(`(${words.join('|')})`, 'gi');

		links.forEach(link => {
			// stash the plain‐text once
			const original = link.getAttribute('data-original-text') || link.textContent;
			link.setAttribute('data-original-text', original);

			// single replace on the plain text
			const highlighted = original.replace(regex, '<span style="font-weight:bold">$1</span>');
			link.innerHTML = highlighted;
		});
	}

	let searchText = document.querySelector('.search_for_free_text');
	if (searchText) {
		searchText.addEventListener('click', (event) => {
			searchTool.searchFreeText(searchText.dataset.genericSearchPageUrl);
		});
	}


	//GAE TRACKING
	var pagetype = 'tp';
	if (isIndexPage) { pagetype = 'ip' };
	const trackedQueryParamKeys = ['d', 'c', 's', 'k', 'text', 'category', 'sg', 'act', 'arrival_date', 'duration_option', 'flexible', 'deals'];
	let getQueryParam = () => {
		let params = window.location.search.replace(/^\?/, '').split('&');
		let queryParams = '';
		params.forEach(p => {
			const key = p.split('=')[0];
			if (!trackedQueryParamKeys.includes(key)) return;
			const i = p.indexOf('=') + 1;
			queryParams += ' ' + p.substring(i);
		});
		return queryParams;
	}

	if (typeof ($('[data-search-status]').attr('data-search-status')) != 'undefined') {
		var status = $('[data-search-status]').attr('data-search-status');
		if (typeof (Cookies.get('search_mobile_tracking')) == 'undefined') {
			gae('search_hero', 'landing--' + 'site' + siteid + '--' + status);
		} else {
			getQueryParam();
			gae('search_hero', 'pageview--' + 'site' + siteid + '--' + status + ' ' + pagetype[0] + 'q=' + getQueryParam());
		};
		Cookies.set('search_mobile_tracking', 'site' + siteid + '--' + status);
	};
	if (typeof (tp_mobile_search_confirmation) != 'undefined' && typeof (Cookies.get('search_mobile_tracking')) != 'undefined') {
		gae('search_hero', 'confirmation-' + tp_mobile_search_confirmation + '--' + Cookies.get('search_mobile_tracking'));
	}
	$('.search__pop-block').on('click touch', function () {
		gae('search_hero', pagetype + '_overview_popular-click');
	});
	$('.search__wrapper input[data-modal]').on('click touch', function (event) {
		if (!event.target.classList.contains('search-tracker-on')) {
			gae('search_hero', pagetype + '_modal_' + $(this).attr('data-modal') + '-open');
			event.target.classList.add('search-tracker-on');
		}
	});
	$('.search__wrapper .search__reset').on('click touch', function () {
		gae('search_hero', pagetype + '_overview_input_' + $(this).parent().find('input[data-modal]').attr('data-modal') + '-reset');
	});
	$('.search__modal a').on('click touch', function () {
		gae('search_hero', pagetype + '_modal_' + $(this).closest('[data-type]').attr('data-type') + '-link');
	});

	// =====================================================================
	// LANDING SEARCH EXPERIMENT LOGIC (plt_landing_search)
	// =====================================================================
	// This section duplicates the landing page search handlers for /sr pages
	// when the experiment is active
	// =====================================================================
	
	if ($('.landing-search').attr('id') === 'new-landing-search') {
		console.log('🎯 [SEARCH_HERO] Initializing landing search experiment handlers on /sr page');
		
		// Prefill category input from URL parameters — only on /sr pages.
		// For c= (Tripaneer slug), read the resolved name from the rendered filter pill.
		// Fall back to slug→title-case, then cq=/q= free-text.
		try {
			var urlParams = new URLSearchParams(window.location.search);
			var categoryParam = window.location.pathname.indexOf('/sr') === 0
				? (urlParams.get('c') || urlParams.get('category'))
				: (urlParams.get('category')); // topic pages: only legacy category= param

			// For topic pages the category slug lives in the path (e.g. /all/c/meditation).
			// Extract it so the Search button can build the correct redirect URL.
			if (!categoryParam) {
				var _pathCatMatch = window.location.pathname.match(/\/c\/([^\/]+)/);
				if (_pathCatMatch && _pathCatMatch[1]) {
					categoryParam = _pathCatMatch[1];
				}
			}

			var categoryQuery = urlParams.get('cq') || urlParams.get('q');
			var categoryName = null;
			if (categoryParam && categoryParam.trim()) {
				// Prefer the server-rendered pill name (e.g. "Yoga Retreats" instead of "Yoga")
				var cParamStr = 'c=' + encodeURIComponent(categoryParam.trim());
				$('.filter-pills__pill').each(function() {
					var href = $(this).find('a[href]').attr('href') || '';
					// The pill's uncheckUrl removes this param — so the href won't contain it
					if (href.indexOf(cParamStr) === -1 && href.indexOf('/sr') !== -1) {
						var pillText = $(this).find('span').first().text().trim();
						if (pillText) { categoryName = pillText; }
						return false; // break
					}
				});
				if (!categoryName) {
					categoryName = decodeURIComponent(categoryParam.trim())
						.split('-')
						.map(function(w) { return w.charAt(0).toUpperCase() + w.slice(1); })
						.join(' ');
				}
			} else if (categoryQuery && categoryQuery.trim()) {
				categoryName = decodeURIComponent(categoryQuery.trim())
					.split(' ')
					.map(function(w) { return w.charAt(0).toUpperCase() + w.slice(1); })
					.join(' ');
			}
			if (categoryName) {
				var $catInputs = $('.js-desktop-search-input-categories, .js-mobile-search-input-categories');
				if ($catInputs.length) {
					$catInputs.val(categoryName);
					console.log('🎯 [SEARCH_HERO] Prefilled category input:', categoryName);
				}
				// Set __expSrParamCat so the Search button includes the current category
				// in the redirect even when the user hasn't interacted with the input.
				if (!window.__expSrParamCat && categoryParam) {
					window.__expSrParamCat = '/sr?c=' + encodeURIComponent(categoryParam.trim()) + '&online_offer=false';
				}
			}
		} catch(e) {
			console.warn('🎯 [SEARCH_HERO] Error prefilling category from URL:', e);
		}
		
		// Prefill destination input from URL query parameter d= (e.g., ?d=bali)
		// Store the prefilled value to prevent it from being reset to default
		var prefilledDestinationValue = null;
		try {
		var urlParams = new URLSearchParams(window.location.search);
		var destinationSlug = urlParams.get('d');
		// For topic pages the destination slug lives in the path (e.g. /all/c/.../d/spain).
		if (!destinationSlug) {
			var _pathDestMatch = window.location.pathname.match(/\/d\/([^\/]+)/);
			if (_pathDestMatch && _pathDestMatch[1]) {
				destinationSlug = _pathDestMatch[1];
			}
		}
		if (destinationSlug && destinationSlug.trim()) {
				// The d= parameter is a slug, we need to get the actual destination name
				// For now, we'll preserve whatever is already in the input if it exists
				// Otherwise, we'll try to get it from a data attribute or use the slug as fallback
				var $destInput = $('#search-bar-input');
				if ($destInput.length) {
					var currentValue = $destInput.val();
					if (currentValue && currentValue.trim()) {
						// Input already has a value (prefilled from server), preserve it
						prefilledDestinationValue = currentValue.trim();
						console.log('🎯 [SEARCH_HERO] Preserving existing destination input value:', prefilledDestinationValue);
					} else {
						// Try to get destination name from data attribute or use slug
						var destName = $('[data-transtag-destination_raw]').attr('data-transtag-destination_raw');
						if (destName && destName.trim()) {
							$destInput.val(destName);
							prefilledDestinationValue = destName.trim();
							console.log('🎯 [SEARCH_HERO] Prefilled destination input from data attribute:', prefilledDestinationValue);
						}
					}
			}
			// Set __expSrParamDest so the Search button includes the destination
			// in the redirect even when the user hasn't interacted with the input.
			if (!window.__expSrParamDest && destinationSlug) {
				window.__expSrParamDest = '/sr?d=' + encodeURIComponent(destinationSlug.trim()) + '&online_offer=false';
				console.log('🎯 [SEARCH_HERO] Set __expSrParamDest from URL:', window.__expSrParamDest);
			}
		}
	} catch(e) {
		console.warn('🎯 [SEARCH_HERO] Error prefilling destination from URL:', e);
	}
	
	// Prevent destination input from being cleared/reset to default
	if (prefilledDestinationValue) {
			var $destInput = $('#search-bar-input');
			// Store original value
			$destInput.data('prefilled-value', prefilledDestinationValue);
			
			// On focus, if input is empty or has default value, restore prefilled value
			$destInput.on('focus.experiment', function() {
				var currentVal = $(this).val();
				var prefilled = $(this).data('prefilled-value');
				// If input is empty or was cleared, restore prefilled value
				if (prefilled && (!currentVal || currentVal.trim() === '')) {
					$(this).val(prefilled);
					console.log('🎯 [SEARCH_HERO] Restored prefilled destination value on focus:', prefilled);
				}
			});
			
			// On blur, if input was cleared, restore prefilled value
			$destInput.on('blur.experiment', function() {
				var currentVal = $(this).val();
				var prefilled = $(this).data('prefilled-value');
				if (prefilled && (!currentVal || currentVal.trim() === '')) {
					$(this).val(prefilled);
					console.log('🎯 [SEARCH_HERO] Restored prefilled destination value on blur:', prefilled);
				}
			});
		}
		
		// Global click handler for category items - sets window.__expSrParamCat
		if (!window.__lpExperimentCatGlobalBound) {
			$(document).on('click', '.experiment-category-item', function(e) {
				e.preventDefault();
				e.stopPropagation();
				var $this = $(this);
		var srParam = $this.attr('data-sr-param');
		var itemName = $this.attr('data-item-name');
		var itemType = $this.attr('data-type') || 'categories';
		// Popular items carry act= and day_activity= from srUrlTripaneer() which create an
		// unwanted sub-category pill (e.g. "Fitness"). Strip them — sg= shows the correct
		// parent-level pill (e.g. "Wellness & Transformation").
		if ($this.attr('data-source') === 'popular' && srParam) {
			try {
				var _ppu = new URL(srParam, window.location.origin);
				_ppu.searchParams.delete('act');
				_ppu.searchParams.delete('day_activity');
				srParam = _ppu.pathname + _ppu.search;
			} catch(_e) {}
		}
	// Normalise: strip act=/day_activity=, transform category= → c= for SR page filtering
	try {
		var _ppu = new URL(srParam, window.location.origin);
		_ppu.searchParams.delete('act');
		_ppu.searchParams.delete('day_activity');
		var _catSlug = _ppu.searchParams.get('category');
		if (_catSlug) { _ppu.searchParams.set('c', _catSlug); _ppu.searchParams.delete('category'); }
		if (!_ppu.searchParams.has('online_offer')) { _ppu.searchParams.set('online_offer', 'false'); }
		srParam = _ppu.pathname + _ppu.search;
	} catch(_e) {}
	console.log('🎯 [GLOBAL CATEGORIES CLICK] sr_param:', srParam);
		gae && gae('search_hero', 'click_' + (itemName || '').split(' ').join('_').split(',').join('') + '--' + itemType);
			$(".js-desktop-search-input-categories, .js-mobile-search-input-categories").val(itemName);
			// store categories sr_param for combined redirect
			window.__expSrParamCat = srParam;
			// Close modal
			$this.closest('.search__modal').addClass('hide');
			});
			window.__lpExperimentCatGlobalBound = true;
			console.log('🎯 [SEARCH_HERO] Global categories click binding active');
		}
		
		const langToId = {
			"fr": {id: 48, lang: "fr"},
			"en": {id: 41, lang: "en"},
			"de": {id: 52, lang: "de"},
			"es": {id: 149, lang: "es"},
			"nl": {id: 39, lang: "nl"},
			"pl": {id: 127, lang: "pl"},
		}

		let idToLang = {};
		for (let key in langToId) {
			idToLang[langToId[key].id] = langToId[key];
		}

		const selectFirstVisibleItem = () => {
			var $firstItem = $('.js-append-compound-search-results .search__autocomplete .experiment-search-item:not(.hidden)').first();
			
			if ($firstItem.length === 0) {
				$firstItem = $('#search__modal-compoundsearch .js-search-default:not(.hide) .experiment-search-item').first();
			}
			
			if ($firstItem.length > 0) {
				var srParam = $firstItem.attr('data-sr-param');
				var itemName = $firstItem.attr('data-item-name');
				var itemType = $firstItem.attr('data-type');
				
				if (srParam && itemName) {
				$("#search-bar-input").val(itemName);
				
				if (itemType === 'destinations' || itemType === 'organizers') {
					// Strip category-context params — destination URLs carry the landing
					// page's sg=/act=/day_activity= which must not bleed into searches.
					try {
						var _dpu2 = new URL(srParam, window.location.origin);
						['sg', 'act', 'day_activity', 'q', 'cq', 'c'].forEach(function(k) { _dpu2.searchParams.delete(k); });
						srParam = _dpu2.pathname + _dpu2.search;
					} catch(_e2) {}
					window.__expSrParamDest = srParam;
				} else if (itemType === 'categories' || itemType === 'tripaneer_categories') {
					window.__expSrParamCat = srParam;
				}
					
					$('#search__modal-compoundsearch').addClass('hide');
					return true;
				}
			}
			return false;
		};

	const selectFirstVisibleCategoryItem = () => {
		// On /sr pages, we don't check the pathname - we always execute if the experiment is active
		if ($('.landing-search').attr('id') === 'new-landing-search') {
			// IMPORTANT: Only select from autocomplete results, not from default categories
			var $autocomplete = $('#search__modal-categories .search__autocomplete');
			var $firstItem;
			
			if ($autocomplete.length > 0) {
				// If autocomplete exists, select from it
				$firstItem = $autocomplete.find('.experiment-category-item:visible').first();
				if ($firstItem.length === 0) {
					$firstItem = $autocomplete.find('.experiment-category-item').first();
				}
				console.log('🎯 [SELECT CAT] Looking in autocomplete, found:', $firstItem.length, 'items');
			} else {
				// If no autocomplete, select from visible default items
				$firstItem = $('#search__modal-categories .experiment-category-item:visible').first();
				if ($firstItem.length === 0) {
					$firstItem = $('#search__modal-categories .experiment-category-item').first();
				}
				console.log('🎯 [SELECT CAT] No autocomplete, looking in defaults, found:', $firstItem.length, 'items');
			}
			
			if ($firstItem.length > 0) {
				var srParam = $firstItem.attr('data-sr-param');
				var itemName = $firstItem.attr('data-item-name');
				var itemType = $firstItem.attr('data-type');
				
				console.log('🎯 [SELECT CAT] Found item:', itemName, 'type:', itemType);
				
				if (srParam && itemName) {
					$('.js-desktop-search-input-categories, .js-mobile-search-input-categories').val(itemName);
					
					window.__expSrParamCat = srParam;
					
					$('#search__modal-categories').addClass('hide');
					
					console.log('🎯 [SELECT CAT] Selected:', itemName);
					return true;
				}
			}
		}
		console.log('🎯 [SELECT CAT] No item selected');
		return false;
	};

		// Mobile/Desktop modal handlers
		var CompoundSearchInput;
		if ($(window).width() < 768) {
			var tpClearerSearchDropdown = $('.tp_clearer_search_dropdown');
			CompoundSearchInput = $('.mobile-search-input-compoundsearch');

	// Debounce flag to prevent touch+click double-firing
	var lastModalOpenTime = 0;
	
	$('.search__modal-toggle, .js-search__modal-toggle').on('click touch', function(e) {
		var modalId = $(this).attr('data-modal');
		var isCategoryInput = $(this).hasClass('js-desktop-search-input-categories') || $(this).hasClass('js-mobile-search-input-categories');
		
		// Prevent duplicate firing from both click and touch
		e.preventDefault();
		e.stopImmediatePropagation();
		
		// Debounce: prevent firing within 300ms
		var now = Date.now();
		if (now - lastModalOpenTime < 300) {
			console.log('🎯 [EXP MOBILE HANDLER] Debounced duplicate event');
			return false;
		}
		lastModalOpenTime = now;
		
		console.log('🎯 [EXP MOBILE HANDLER] Click/touch on:', {
			modalId: modalId,
			isCategoryInput: isCategoryInput,
			categoryModalOpen: !$('#search__modal-categories').hasClass('hide'),
			modalCurrentlyHidden: $('#search__modal-'+modalId).hasClass('hide'),
			bodyHasNoscroll: $('body').hasClass('noscroll'),
			classes: $(this).attr('class')
		});
		
		// Skip if this is a category input (handled by dedicated category handler)
		if (isCategoryInput) {
			console.log('🎯 [EXP MOBILE HANDLER] Skipping category input');
			return false; // Let the dedicated category handler manage category modal
		}
		
		// Skip if category modal is already open (don't steal focus from category input)
		if (!$('#search__modal-categories').hasClass('hide')) {
			console.log('🎯 [EXP MOBILE HANDLER] Category modal is open, not switching to destination modal');
			return false;
		}
		
		console.log('🎯 [EXP MOBILE HANDLER] Opening modal:', modalId);
		
		$('body').attr('data-pos', $(window).scrollTop());
		$('body,html').addClass('noscroll');
		$('input').blur();
		
		var $modal = $('#search__modal-'+modalId);
		$modal.removeClass('hide');
		// Remove any inline display styles that might be blocking visibility
		$modal.css('display', '');
		
		setTimeout(function() {
			console.log('🎯 [EXP MOBILE HANDLER] After opening:', {
				modalHidden: $modal.hasClass('hide'),
				bodyHasNoscroll: $('body').hasClass('noscroll'),
				modalExists: $modal.length,
				inlineStyle: $modal.attr('style')
			});
			$modal.find('input').focus();
		}, 100);
		
		var evt = null;
		if (modalId === 'arrival') { evt = 'tp_modal_arrival-open'; }
		else if (modalId === 'categories' || modalId === 'activity') { evt = 'tp_modal_activity-open'; }
		else if (modalId === 'compoundsearch') { evt = 'tp_modal_destination-open'; }
		if (evt) { try { gae('search_hero', evt); } catch(e) {} }
		
		return false;
	});
		} else {
			var tpClearerSearchDropdown = $('.tp_clearer_search_dropdown');
			CompoundSearchInput = $('.desktop-search-input-compoundsearch');

	$('.search__modal-toggle').on('focus', function(e) {
		var modalId = $(this).attr('data-modal');
		var isCategoryInput = $(this).hasClass('js-desktop-search-input-categories') || $(this).hasClass('js-mobile-search-input-categories');
		
		console.log('🎯 [EXP FOCUS HANDLER] Focus on:', {
			modalId: modalId,
			isCategoryInput: isCategoryInput,
			hasValue: !!$(this).val(),
			categoryModalOpen: !$('#search__modal-categories').hasClass('hide'),
			classes: $(this).attr('class')
		});
		
		// Skip if this is a category input (handled by experiment handler)
		if (isCategoryInput) {
			console.log('🎯 [EXP FOCUS HANDLER] Skipping category input');
			e.stopImmediatePropagation();
			e.preventDefault();
			return false; // Let the experiment handler manage category modal
		}
		
		// Skip if category modal is already open (don't steal focus from category input)
		if (!$('#search__modal-categories').hasClass('hide')) {
			console.log('🎯 [EXP FOCUS HANDLER] Category modal is open, not switching to destination modal');
			$(this).blur(); // Remove focus from destination input
			return false;
		}
		
		$('.search__modal').addClass('hide');
		if($(this).val()){
			$('#search__modal-'+modalId).removeClass('hide');
			
			var evt = null;
			if (modalId === 'arrival') { evt = 'tp_modal_arrival-open'; }
			else if (modalId === 'categories' || modalId === 'activity') { evt = 'tp_modal_activity-open'; }
			else if (modalId === 'compoundsearch') { evt = 'tp_modal_destination-open'; }
			if (evt) { try { gae('search_hero', evt); } catch(e) {} }
		}
	});

		$('body').on('click touch', function(e){
			console.log('🎯 [BODY CLICK] Body clicked:', {
				target: e.target.className,
				isFlexible: e.target.classList.contains('landing-filter_flexible'),
				isAccordion: e.target.classList.contains('landing-search__accordion-toggle'),
				isToggle: $(e.target).hasClass('search__modal-toggle'),
				parentsSearchWrapper: $(e.target).parents('.search__wrapper').length
			});
			
			if(e.target.classList.contains('landing-filter_flexible') || e.target.classList.contains('landing-search__accordion-toggle')) {
				console.log('🎯 [BODY CLICK] Skipping flexible/accordion');
				return;
			}
			// Don't close if clicking on an input to open the modal
			if ($(e.target).hasClass('search__modal-toggle') || $(e.target).hasClass('js-search__modal-toggle')) {
				console.log('🎯 [BODY CLICK] Clicked modal toggle, not closing');
				return;
			}
			if ( $(e.target).parents('.search__wrapper').length == 0 ) {
				console.log('🎯 [BODY CLICK] Clicked outside modal, closing all modals');
				$('.search__modal').addClass('hide');
				$('.search__modal-toggle').blur();
			} else {
				console.log('🎯 [BODY CLICK] Clicked inside search wrapper, not closing');
			}
		});
		}

	// Filter-pill removal — strip experiment category params (q=, cq=, day_activity=, category=)
	// that the server-generated uncheckUrl doesn't know about.
	// Each pill only removes ONE param (sg= OR act=), so we detect a category removal
	// by comparing the current URL with the target uncheckUrl.
	if (!window.__expFilterPillBound) {
		$(document).on('click', '.filter-pills__pill a', function(e) {
			if ($('.landing-search').attr('id') !== 'new-landing-search') return;
			var href = $(this).attr('href');
			if (!href) return;
			try {
				var current = new URLSearchParams(window.location.search);
				var parsed = new URL(href, window.location.origin);
				// Detect if this pill removes a category-related param (sg= or act=)
				var removedCategoryParam =
					(current.has('sg') && !parsed.searchParams.has('sg')) ||
					(current.has('act') && !parsed.searchParams.has('act'));
				if (removedCategoryParam) {
					// Strip all category params the experiment added — the server only
					// knows about sg= and act=, not q=, cq=, day_activity=, category=.
					parsed.searchParams.delete('sg');
					parsed.searchParams.delete('act');
					parsed.searchParams.delete('q');
					parsed.searchParams.delete('cq');
					parsed.searchParams.delete('day_activity');
					parsed.searchParams.delete('category');
				}
				var cleanUrl = parsed.pathname + (parsed.search ? parsed.search : '');
				e.preventDefault();
				window.location.assign(cleanUrl);
			} catch(_e) {}
		});
		window.__expFilterPillBound = true;
	}

	// Search button handler
	if (!window.__expSearchBtnBound) {
		$(document).on('click', '.jumbotron-show-all', function(ev){
			if ($('.landing-search').attr('id') !== 'new-landing-search') return;
				ev.preventDefault();
				if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
				
			var inputValue = $('#search-bar-input').val().trim();
			
		var dest = window.__expSrParamDest;
		var cat = window.__expSrParamCat;
		var dateQuery = window.__expSrParamDateQuery;

		// If the destination input is empty, discard any previously stored destination.
		if (!inputValue) { dest = null; }
		// If the category input is empty, discard any previously stored category.
		// Do NOT use :visible — the input may be inside a closed modal and still hold a value.
		var _catInputVal = ($('.js-desktop-search-input-categories').val() || $('.js-mobile-search-input-categories').val() || '').trim();
		if (!_catInputVal) { cat = null; }

			// On /sr pages: preserve what the user didn't touch.
			//
			// • Category changed  → use the new category URL as the complete base
			//   (it carries the correct sg/act/label/q/etc.), then patch in the
			//   destination and carry over dates.
			// • Only destination / dates changed → start from the current page URL
			//   and swap only those params so nothing else is lost.
		if (window.location.pathname.indexOf('/sr') === 0) {
			if (!dest && !cat && !dateQuery) {
				// If the user explicitly cleared the category input, rebuild the URL
				// without any category params instead of reloading with the old ones.
				if (!_catInputVal) {
					var _cs0 = new URLSearchParams(window.location.search);
					var _urlClean = new URL('/sr', window.location.origin);
					_urlClean.searchParams.set('online_offer', 'false');
					// Keep destination if its input is still filled
					if (inputValue) {
						var _dClean = _cs0.get('d');
						if (_dClean) { _urlClean.searchParams.set('d', _dClean); }
					}
					['arrival_date', 'flexible'].forEach(function(k) {
						if (_cs0.has(k)) { _urlClean.searchParams.set(k, _cs0.get(k)); }
					});
					console.log('🎯 [COMBINED SEARCH /sr] category cleared, navigating to:', _urlClean.pathname + _urlClean.search);
					window.location.assign(_urlClean.pathname + _urlClean.search);
				} else {
					window.location.reload();
				}
				return;
			}
			try {
				var currentSearch = new URLSearchParams(window.location.search);
				var urlFinal;

				// __expSrParamDateQuery stores the full URL search string with updated
			// arrival_date/flexible (via updateQueryStringParameter). Extract only
			// the date params so stale dest/category params don't bleed through.
			var dateParams = {};
			if (dateQuery) {
				var dqStr = dateQuery.charAt(0) === '?' ? dateQuery.substring(1) : dateQuery;
				var dqParsed = new URLSearchParams(dqStr);
				['arrival_date', 'flexible'].forEach(function(k) {
					if (dqParsed.has(k)) { dateParams[k] = dqParsed.get(k); }
				});
			}

				if (cat) {
					// Use the new category URL as the authoritative base so that all
					// category-specific params (sg, act, label, q, day_activity, …)
					// come exactly from the category selection.
					var catUrl = new URL(cat, window.location.origin);
					catUrl.searchParams.delete('page');

					// Destination: prefer newly-selected one, else keep current d=
					var newD = null;
					if (dest) {
						try { newD = new URL(dest, window.location.origin).searchParams.get('d'); } catch(_e) {}
					}
					var finalD = newD || currentSearch.get('d');
					if (finalD) { catUrl.searchParams.set('d', finalD); }

					// Dates: apply only arrival_date/flexible (new or carried over)
					['arrival_date', 'flexible'].forEach(function(k) {
						if (dateParams[k] !== undefined) {
							catUrl.searchParams.set(k, dateParams[k]);
						} else if (currentSearch.has(k)) {
							catUrl.searchParams.set(k, currentSearch.get(k));
						}
					});

					urlFinal = catUrl.pathname + catUrl.search;
			} else {
				if (_catInputVal) {
					// Category input still has a value — the user didn't clear it, they
					// just didn't re-select it (e.g. only changed dates or destination).
					// Keep all current URL params (including category) and only update
					// the parts that actually changed.
					var urlBase = new URL(window.location.href);
					urlBase.searchParams.delete('page');
					// Strip sub-category activity filters — the category input is
					// authoritative and act=/day_activity= from a previous narrower URL
					// must not persist when the user has a broader category selected.
					urlBase.searchParams.delete('act');
					urlBase.searchParams.delete('day_activity');

					if (dest) {
						try {
							var newD2 = new URL(dest, window.location.origin).searchParams.get('d');
							if (newD2) { urlBase.searchParams.set('d', newD2); }
						} catch(_e) {}
					} else if (!inputValue) {
						urlBase.searchParams.delete('d');
					}

					['arrival_date', 'flexible'].forEach(function(k) {
						if (dateParams[k] !== undefined) { urlBase.searchParams.set(k, dateParams[k]); }
					});

					urlFinal = urlBase.pathname + urlBase.search;
				} else {
					// Category input is empty — user explicitly cleared it.
					// Build a clean URL with no category params, keeping only dest and dates.
					var urlBase = new URL('/sr', window.location.origin);
					urlBase.searchParams.set('online_offer', 'false');

					var keepD = null;
					if (dest) {
						try { keepD = new URL(dest, window.location.origin).searchParams.get('d'); } catch(_e) {}
					} else if (inputValue) {
						keepD = currentSearch.get('d');
					}
					if (keepD) { urlBase.searchParams.set('d', keepD); }

					['arrival_date', 'flexible'].forEach(function(k) {
						if (dateParams[k] !== undefined) { urlBase.searchParams.set(k, dateParams[k]); }
						else if (currentSearch.has(k)) { urlBase.searchParams.set(k, currentSearch.get(k)); }
					});

					urlFinal = urlBase.pathname + urlBase.search;
				}
			}

					console.log('🎯 [COMBINED SEARCH /sr] redirecting to:', urlFinal);
					window.location.assign(urlFinal);
				} catch(e) {
					console.warn('🎯 [COMBINED SEARCH /sr] error building URL, falling through:', e);
				}
				return;
			}

			if (!dest && !cat && !dateQuery) {
				var prefix = selectedLanguage == 'en' ? '' : '/' + selectedLanguage;
				window.location.href = prefix + '/sr';
				return;
			}
			console.log('🎯 [COMBINED SEARCH] globals before redirect:', { dest: dest, cat: cat, date: dateQuery });
		var primary = dest || cat;
			var other = dest && cat ? (primary === dest ? cat : dest) : null;
			var url = primary;
			if (dest && !cat) {
				try {
					var _p = new URL(primary, window.location.origin);
					_p.searchParams.delete('q');
					url = _p.pathname + (_p.search ? _p.search : '');
				} catch(_e) {}
			}
			if (other) {
					try {
						var p = new URL(primary, window.location.origin);
						var o = new URL(other, window.location.origin);
						
					// Remove q= parameter from destination URL (q= is only for categories)
					if (p.searchParams.has('q')) {
						p.searchParams.delete('q');
					}
					// Remove act= and day_activity= from the destination URL — these are
					// sub-category filters baked into landing-page destination links (e.g.
					// "USA" on a Fitness page links to ?act=3932&day_activity=false). When
					// the user explicitly picks a category, the category URL is authoritative
					// for activity filtering so these must not bleed through.
					p.searchParams.delete('act');
					p.searchParams.delete('day_activity');
					
					try {
							var pPath = p.pathname || '';
							var pCat = pPath.match(/\/c\/([^\/?#]+)/);
							if (pCat && pCat[1]) { p.searchParams.set('c', pCat[1]); }
							var pDest = pPath.match(/\/d\/([^\/?#]+)/);
							if (pDest && pDest[1]) { p.searchParams.set('d', pDest[1]); }
							var pStyle = pPath.match(/\/styles?\/([^\/?#]+)/);
							if (pStyle && pStyle[1]) { p.searchParams.set('sg', pStyle[1]); }
						} catch(_e) {}
						try {
							var path = o.pathname || '';
							var mCat = path.match(/\/c\/([^\/?#]+)/);
							if (mCat && mCat[1]) { p.searchParams.set('c', mCat[1]); }
							var mDest = path.match(/\/d\/([^\/?#]+)/);
							if (mDest && mDest[1] && !p.searchParams.get('d')) { p.searchParams.set('d', mDest[1]); }
							var mStyle = path.match(/\/styles?\/([^\/?#]+)/);
							if (mStyle && mStyle[1]) { p.searchParams.set('sg', mStyle[1]); }
						} catch(_e) {}
						
					// Copy params from other URL, prioritizing q= and sg= from category URL
					o.searchParams.forEach(function(value, key){
						// Always use q= and sg= from category URL (other), not from destination
						if (key === 'q' || key === 'sg') {
							p.searchParams.set(key, value);
						} else {
							// For other params, only set if not already present
							if (!p.searchParams.has(key)) {
								p.searchParams.set(key, value);
							}
						}
					});
						
						url = p.pathname + (p.search ? p.search : '');
					} catch(e) {
						var sep = (url && url.indexOf('?')>-1 ? '&' : '?');
						var otherQs = other && other.split ? (other.split('?')[1] || '') : '';
						if (otherQs) { 
							// Remove q= from primary URL query string if present
							var primaryQs = primary && primary.split ? (primary.split('?')[1] || '') : '';
							if (primaryQs && primaryQs.includes('q=')) {
								var params = new URLSearchParams(primaryQs);
								params.delete('q');
								var cleanPrimaryQs = params.toString();
								url = (primary.split('?')[0] || '/sr') + (cleanPrimaryQs ? '?' + cleanPrimaryQs : '');
							}
							url = (url || '/sr') + sep + otherQs; 
						}
					}
				}
			if (dateQuery) {
				// Extract only arrival_date and flexible — dateQuery may be built from
				// window.location.search which can carry stale act=, day_activity=, etc.
				var _dqStr = dateQuery.charAt(0) === '?' ? dateQuery.substring(1) : dateQuery;
				var _dqParsed = new URLSearchParams(_dqStr);
				var _dateParts = [];
				['arrival_date', 'flexible'].forEach(function(k) {
					if (_dqParsed.has(k)) { _dateParts.push(k + '=' + encodeURIComponent(_dqParsed.get(k))); }
				});
				var cleanDateQuery = _dateParts.join('&');
				
				if (url) {
					if (cleanDateQuery) {
						var sep2 = (url.indexOf('?') > -1) ? '&' : '?';
						url = url + sep2 + cleanDateQuery;
					}
				} else {
					url = '/sr?' + cleanDateQuery;
					}
				}
				console.log('🎯 [COMBINED SEARCH] redirecting to:', url);
				window.location.assign(url);
			});
			window.__expSearchBtnBound = true;
		}

		// Input blur handlers
		// Track if destination input actually had focus
		var destinationInputWasFocused = false;
		CompoundSearchInput.on('focus', function() {
			destinationInputWasFocused = true;
		});
		
		CompoundSearchInput.on('blur', function(e) {
			// Ignore blur if focus is moving to another element within the modal
			var relatedTarget = e.relatedTarget;
			if (relatedTarget && $(relatedTarget).closest('#search__modal-compoundsearch').length > 0) {
				console.log('🎯 [BLUR DEST] Focus moved within modal, ignoring blur');
				destinationInputWasFocused = false;
				return;
			}
			
			// Only process blur if input actually had focus
			if (!destinationInputWasFocused) {
				console.log('🎯 [BLUR DEST] Input was not actually focused, ignoring blur');
				return;
			}
			
			destinationInputWasFocused = false;
			
			var inputValue = $(this).val().trim();
			
			if (!inputValue || inputValue.length === 0) {
				return;
			}
			
		if (!window.__expSrParamDest && !window.__expSrParamCat) {
			setTimeout(function() {
				// Re-check: user may have clicked an item between blur and this timeout.
				if (!window.__expSrParamDest) {
					var selected = selectFirstVisibleItem();
				}
			}, 150);
		} else {
			console.log('🎯 [BLUR DEST] Item already selected, skipping auto-select');
		}
		});

		var CategoriesSearchInput = $('.js-desktop-search-input-categories, .js-mobile-search-input-categories');
		
	// Categories autocomplete on keyup
	CategoriesSearchInput.on('input keyup', function(e) {
		var val = $(this).val();
		console.log('🎯 [EXP CAT KEYUP] Key pressed, value:', val, 'keyCode:', e.keyCode || e.which);
		
		window.__expSrParamCat = null; // Reset when user types
		
		if ((e.keyCode || e.which) === 13) {
				if (val && val.trim().length > 0 && !window.__expSrParamCat) {
					selectFirstVisibleCategoryItem();
				}
				return;
			}
			
		if (!val || !val.trim()) {
			// Keep both inputs in sync: clearing one must clear the other so the
			// _catInputVal check (desktop || mobile) correctly sees an empty category.
			CategoriesSearchInput.not(this).val('');
			$('#search__modal-categories .search__autocomplete').remove();
			$('#search__modal-categories .js-search-default').removeClass('hide');
			return;
		}
			
		$('#search__modal-categories .js-search-default').addClass('hide');
		clearTimeout(window.__catExpDebounce);
		
	clearTimeout(window.__catExpQueryGae);
	window.__catExpQueryGae = setTimeout(function() {
		gae('search_hero', pagetype + '_cat_query_' + val);
	}, 600);

	window.__catExpDebounce = setTimeout(function(){
		var prefix = selectedLanguage == 'en' ? '' : '/' + selectedLanguage;
		var indexes = (siteid == '4') ? 'styles,tripaneer_categories,listings' : 'styles,categories,listings';
			var query = prefix + '/searching?dest_id='+destinationID+'&index=' + indexes + '&query=' + encodeURI(val);
			
			console.log('🎯 [EXP CAT AUTOCOMPLETE] Fetching results for:', val, 'from:', query);
			
			var xhr = new XMLHttpRequest();
				xhr.open('GET', query);
				xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				xhr.send(null);
				
				xhr.onreadystatechange = function(){
					if (xhr.readyState !== 4) return;
					
					$('#search__modal-categories .search__autocomplete').remove();
					var resWrap = $("<div class='search__autocomplete'></div>");
					
				if (xhr.status === 200) {
					var data = JSON.parse(xhr.responseText);
					var types = (siteid == '4') ? ['tripaneer_categories','styles','listings'] : ['categories','styles','listings'];
					
					types.forEach(function(type){
							if (!(data[type] && data[type].hits && data[type].hits.hits.length)) return;
							
							var title = $('[data-transtag-'+type+']').attr('data-transtag-'+type);
							var group = $("<ul class='search__accordion search__accordion-lvl1'></ul>");
							group.append("<li class='search__accordion-item search__accordion-item-lvl1'><h4>"+title+":</h4></li>");
							var list = $("<ul class='search__accordion search__accordion-lvl2 active'></ul>");
							
							for (var i=0; i<Math.min(5, data[type].hits.hits.length); i++) {
								var hit = data[type].hits.hits[i]._source;
								var name = hit.name + (hit.country ? (', ' + hit.country) : '');
					var path = (hit.language && hit.language != 41) ? ('/' + idToLang[hit.language].lang + hit.url) : hit.url;
					// Normalise: strip sg=, transform category= → c= for proper SR page filtering
					try {
						var _cp = new URL(path, window.location.origin);
						_cp.searchParams.delete('sg');
						var _catSlug = _cp.searchParams.get('category');
						if (_catSlug && type === 'tripaneer_categories') {
							_cp.searchParams.set('c', _catSlug);
							_cp.searchParams.delete('category');
						}
						path = _cp.pathname + _cp.search;
					} catch(_e) {}
				path += (path.indexOf('?')>-1 ? '&' : '?') + 'online_offer=false';
							
							list.append(`
								<li class='search-accordion-item search-accordion-item-lvl2 experiment-category-item'
									data-type='${type}'
									data-sr-param='${path}'
									data-item-name='${name}'
									style='cursor:pointer'
								>${name}</li>`);
							}
							
					group.append(list);
					resWrap.append(group);
				});
				
				console.log('🎯 [KEYUP CAT] Appending', resWrap.children().length, 'result groups to category modal');
				$('#search__modal-categories .js-append-compound-search-results').append(resWrap);
			} else {
				console.log('🎯 [KEYUP CAT] XHR failed, showing default categories');
				$('#search__modal-categories .js-search-default').removeClass('hide');
			}
				};
			}, 200);
	});
	
	// Categories blur handler - auto-select first visible item
	// Track if categories input actually had focus
	var categoriesInputWasFocused = false;
	// Unbind any existing handlers on category inputs that might interfere
	CategoriesSearchInput.off('click touch focus');
	
	// Only handle click to open modal, not focus (to allow typing)
	CategoriesSearchInput.on('click.experiment', function(e) {
		var $clickedInput = $(this);
		
		// Don't preventDefault - we need typing to work!
		// Only stop propagation to prevent other click handlers
		e.stopPropagation();
		e.stopImmediatePropagation();
		
		// Debug: Check which modals exist
		console.log('🎯 [CLICK CAT] Modal check:', {
			categoryModalExists: $('#search__modal-categories').length,
			compoundModalExists: $('#search__modal-compoundsearch').length,
			categoryModalHidden: $('#search__modal-categories').hasClass('hide'),
			compoundModalHidden: $('#search__modal-compoundsearch').hasClass('hide'),
			clickedInputHasValue: !!$clickedInput.val()
		});
		
	// Ensure category modal is open and other modals are closed
	$('.search__modal').addClass('hide');
	$('.js-search__modal').addClass('hide');
	$('#search__modal-compoundsearch').addClass('hide');
	$('#search__modal-destination').addClass('hide');
	$('#search__modal-categories').removeClass('hide');

	// If the input is empty, show default categories and clear any stale autocomplete
	if (!$clickedInput.val() || !$clickedInput.val().trim()) {
		$('#search__modal-categories .search__autocomplete').remove();
		$('#search__modal-categories .js-search-default').removeClass('hide');
	}
	
	// Focus the modal's internal input (not the trigger input) to prevent iOS from pushing the page
	setTimeout(function() {
		var $modalInput = $('#search__modal-categories').find('input:visible').first();
		if ($modalInput.length) {
			$modalInput.focus();
		}
		console.log('🎯 [CLICK CAT] Re-focused modal input');
	}, 50);
	
	console.log('🎯 [CLICK CAT] Category modal opened, destination modal closed');
	});
	
	// Track focus for blur handler
	CategoriesSearchInput.on('focus.experiment', function() {
		categoriesInputWasFocused = true;
		console.log('🎯 [FOCUS CAT] Input focused');
	});
	
	CategoriesSearchInput.on('blur', function(e) {
		// Ignore blur if focus is moving to another element within the modal
		var relatedTarget = e.relatedTarget;
		if (relatedTarget && $(relatedTarget).closest('#search__modal-categories').length > 0) {
			console.log('🎯 [BLUR CAT] Focus moved within modal, ignoring blur');
			categoriesInputWasFocused = false;
			return;
		}
		
		// Only process blur if input actually had focus
		if (!categoriesInputWasFocused) {
			console.log('🎯 [BLUR CAT] Input was not actually focused, ignoring blur');
			return;
		}
		
		categoriesInputWasFocused = false;
		
		var inputValue = $(this).val().trim();
		
		if (!inputValue || inputValue.length === 0) {
			return;
		}
		
		if (!window.__expSrParamCat) {
			setTimeout(function() {
				if (!window.__expSrParamCat) {
					// Check if autocomplete results exist
					var $autocomplete = $('#search__modal-categories .search__autocomplete');
					if ($autocomplete.length > 0) {
						console.log('🎯 [BLUR CAT] Autocomplete results found, selecting first item');
						var selected = selectFirstVisibleCategoryItem();
					} else {
						console.log('🎯 [BLUR CAT] No autocomplete results yet, skipping');
					}
				} else {
					console.log('🎯 [BLUR CAT] Category already selected by click, skipping auto-select');
				}
			}, 350); // Wait for autocomplete to render (200ms debounce + 150ms buffer)
		} else {
			console.log('🎯 [BLUR CAT] Category already selected, skipping auto-select');
		}
	});
	
	// Autocomplete search on keyup
	CompoundSearchInput.keyup(function (e) {
			const searchText = document.querySelector('.search_for_free_text');
			searchText ? searchText.innerHTML = `Search for <b>${e.target.value}</b>` : null;

		window.__expSrParamDest = null;

		$('#search__modal-' + $(this).attr('data-modal')).removeClass('hide');
			let code = e.keyCode || e.which;

			if (code == 13) {
				var inputValue = $(this).val().trim();
				if (inputValue && inputValue.length > 0 && !window.__expSrParamDest && !window.__expSrParamCat) {
					selectFirstVisibleItem();
				}
				searchText ? searchText.click() : null;
			}
			else {
				var val = $(this).val()
				var elem = $(this)

				if (val.length > 0) {
					clearTimeout(window.full_search_query);
					window.full_search_query = setTimeout(function () {
						gae('search_hero', 'query_' + val);
					}, 600);

					$('#compound_search .search__autocomplete-noresults').addClass('hide');
					$('#compound_search .search__autocomplete-noresults').parent().addClass('hide');

					var prefix = selectedLanguage == 'en' ? '' : '/' + selectedLanguage;
					var indexes = 'destinations,organizers';
					var query = prefix + '/searching?dest_id=' + destinationID + '&index=' + indexes + '&query=' + encodeURI(val);
					var lang = langToId[selectedLanguage] || langToId["en"]

					var xhr = new XMLHttpRequest();
					xhr.open('GET', query);
					xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
					xhr.send(null);
					xhr.onreadystatechange = function () {
						if ($(elem).val() != val) {
							return;
						}
						if (xhr.readyState === 4) {
							$('#compound_search .search__autocomplete-noresults').addClass('hide');
							$('#compound_search .search__autocomplete-noresults').parent().addClass('hide');
							$('.js-search-default').removeClass('hide');
							$('#compound_search .search__autocomplete').remove();

							var res = $("<div class='search__autocomplete'></div>");

							if (xhr.status === 200) {
								var data = JSON.parse(xhr.responseText);
								var types = ['destinations', 'organizers'];

								var seen = {}
								var total = 0;

								const itemLimit = 4;

								types.forEach((type, t) => {
									if (data[type] && data[type].hits.hits.length > 0) {
										var resGroup = $("<ul class='search__accordion search__accordion-lvl1'></ul>");
										var title = $('[data-transtag-' + type + ']').attr('data-transtag-' + type);
										
										resGroup.append(`<li class='search__accordion-item search__accordion-item-lvl1'><h4>` + title + ":</h4></li>");
										resGroup.append(`<ul class='search__accordion search__accordion-lvl2 active'></ul>`);

										var resGroupItems = resGroup.find('.search__accordion-lvl2');
										var typeItems = 0;

										for (var i = 0; i < data[type].hits.hits.length; i++) {
											var hit = data[type].hits.hits[i]._source
											var name = hit.name;
											var path = hit.url;

											if (hit.country) {
												name += ', ' + hit.country
											}

											if (type == "destinations") {
												if (+siteid === 4) {
													path = hit.path;
												} else {
													if (typeof (filteredOnActivity) != 'undefined') {
														var beforeUrl = decodeURIComponent(window.location);
														var destinationPosition = beforeUrl.indexOf('/d/');

														if (destinationPosition > 0) {
															beforeUrl = beforeUrl.substring(0, destinationPosition);
														}
														if (beforeUrl.indexOf('?') > 0) {
															beforeUrl = location.href.substring(0, location.href.indexOf('?'));
														}
														beforeUrl = removeHost(beforeUrl);
														path = beforeUrl + '/d/' + hit.paths[lang.id];
													} else {
														var langPart = hit.language != 41 ? '/' + idToLang[hit.language].lang : '';
														path = langPart + '/all/d/' + hit.paths[lang.id];
													}
												}
											}

											var id = path;

											if (typeof (hit.destination_id) != 'undefined') {
												var id = hit.destination_id;
											};

											if (seen[id]) continue;
											seen[id] = true;

											if (isIndexPage || isTopicPage) {
												var urls = ['/all/c/budget-retreats', '/all/d/asia-and-oceania/india', '/all/d/europe/united-kingdom'];
												for (j = 0; j < urls.length; j++) {
													if (path == urls[j]) {
														if (path.indexOf('?') > -1) {
															path += '&search';
														} else {
															path += '?search';
														};
													};
												};
											};

									if (path.indexOf('?') > -1) { path += '&q=' + val; } else { path += type != 'listings' ? '?q=' + val : ''; }

										resGroupItems.append(`<li
											data-type="${type}"
											data-sr-param="${path}"
											data-item-name="${name}"
												class='
													search-accordion-item
													search-accordion-item-lvl2
													search-accordion-item--${type}
													experiment-search-item
													${typeItems > itemLimit ? 'hidden' : ''}
												'
												style="cursor: pointer;"
											>
												${name}
											</li>`);
											typeItems++;
											total++;
										}
										res.append(resGroup);
									}
								});

							if (total > 0) {
								// Append ONLY to destination modal, not category modal
								$('#search__modal-compoundsearch .js-append-compound-search-results').append(res);
								
								// Bind click handlers
								if (!window.__lpExperimentDelegationBound) {
										console.log('🎯 [AUTOCOMPLETE] Binding delegation once for experiment items');
										$('#compound_search').on('mousedown click', '.experiment-search-item', function(e) {
											e.preventDefault();
											e.stopPropagation();
											var $this = $(this);
											var srParam = $this.attr('data-sr-param');
											var itemName = $this.attr('data-item-name');
											var itemType = $this.attr('data-type');
											console.log('🎯 [AUTOCOMPLETE CLICK] sr_param:', srParam);
											console.log('🎯 [AUTOCOMPLETE CLICK] item_name:', itemName);
											console.log('🎯 [AUTOCOMPLETE CLICK] item_type:', itemType);
										gae('search_hero', 'click_' + itemName.split(' ').join('_').split(',').join('') + '--' + itemType);
										try { gae('search_hero', 'tp_modal_destination-link'); } catch(e) {}
										// Strip category-context params from dest URL — popular destination links
										// are contextual to the landing page and carry sg=, act=, day_activity=
										// which must not bleed into the combined search URL.
										try {
											var _dpu = new URL(srParam, window.location.origin);
											['sg', 'act', 'day_activity', 'q', 'cq', 'c'].forEach(function(k) { _dpu.searchParams.delete(k); });
											srParam = _dpu.pathname + _dpu.search;
										} catch(_e) {}
										$("#search-bar-input").val(itemName);
										window.__expSrParamDest = srParam;
										$this.closest('.search__modal').addClass('hide');
										console.log('✅ [AUTOCOMPLETE CLICK] Handled successfully');
										});
										window.__lpExperimentDelegationBound = true;
									}
									if (!window.__lpExperimentCategoriesDelegationBound) {
										console.log('🎯 [AUTOCOMPLETE] Binding delegation once for experiment category items');
									$('#search__modal-categories').on('mousedown click', '.experiment-category-item', function(e) {
										e.preventDefault();
										e.stopPropagation();
										var $this = $(this);
									var srParam = $this.attr('data-sr-param');
									var itemName = $this.attr('data-item-name');
									var itemType = $this.attr('data-type');
								// Popular items carry act= and day_activity= from srUrlTripaneer() which create an
								// unwanted sub-category pill (e.g. "Fitness"). Strip them — sg= shows the correct
								// parent-level pill (e.g. "Wellness & Transformation").
								if ($this.attr('data-source') === 'popular' && srParam) {
									try {
										var _ppu2 = new URL(srParam, window.location.origin);
										_ppu2.searchParams.delete('act');
										_ppu2.searchParams.delete('day_activity');
										srParam = _ppu2.pathname + _ppu2.search;
									} catch(_e) {}
								}
								// Popular items (server-side rendered) don't have cq= — typed items do.
								if (srParam && itemName && srParam.indexOf('cq=') === -1) {
									var _qVal = (itemName || '').toLowerCase();
									srParam += (srParam.indexOf('?') > -1 ? '&' : '?') + 'cq=' + encodeURIComponent(_qVal);
									if (srParam.indexOf('online_offer') === -1) { srParam += '&online_offer=false'; }
								}
									console.log('🎯 [AUTOCOMPLETE CATEGORIES CLICK] sr_param:', srParam);
										gae('search_hero', 'click_' + itemName.split(' ').join('_').split(',').join('') + '--' + itemType);
										try { gae('search_hero', 'tp_modal_activity-link'); } catch(e) {}
										$('.js-desktop-search-input-categories').val(itemName);
										window.__expSrParamCat = srParam;
									});
										window.__lpExperimentCategoriesDelegationBound = true;
									}

									$('.js-search-default').addClass('hide');
								} else {
									$('#compound_search .search__autocomplete').remove();
									$('#compound_search .search__autocomplete-noresults').removeClass('hide');
									$('#compound_search .search__autocomplete-noresults').parent().removeClass('hide');
									$('.js-search-default').removeClass('hide');
								};
							} else {
								$('#compound_search .search__autocomplete').remove();
								$('#compound_search .search__autocomplete-noresults').removeClass('hide');
								$('#compound_search .search__autocomplete-noresults').parent().addClass('hide');
								$('.js-search-default').removeClass('hide');
							}
						}
					}
				} else {
					$('#compound_search .search__autocomplete').remove();
					$('#compound_search .search__autocomplete-noresults').addClass('hide');
					$('#compound_search .search__autocomplete-noresults').parent().addClass('hide');
					$('.js-search-default').removeClass('hide');
					$('#search__modal-' + $(this).attr('data-modal')).addClass('hide');
				};
			}
		});
		
		// Date picker handler for experiment - must run first and stop propagation
		$('#availability-options .month').off('changeDate').on('changeDate', function(event) {
			var arrivalDate, arrivalDateString;
			arrivalDate = $(this).datepicker('getUTCDate');
			
			if (arrivalDate && !isNaN(arrivalDate) && $.fn.datepicker && $.fn.datepicker.DPGlobal) {
			arrivalDateString = $.fn.datepicker.DPGlobal.formatDate(arrivalDate, 'yyyy-mm-dd', 'en');
			
			// Build a clean date-only query — do NOT use window.location.search as the
			// base because it can carry stale act=, day_activity=, sg=, etc. that would
			// bleed into the redirect URL when the combined search handler appends it.
			var flexVal = $('.filter_flexible:visible').val() || '0';
			var query = 'arrival_date=' + encodeURIComponent(arrivalDateString) + '&flexible=' + encodeURIComponent(flexVal);
			
			// Store date query globally for combined redirect
			window.__expSrParamDateQuery = query;
			console.log('🎯 [DATE PICKER] Stored date query:', query);
				
			// Update the arrival date input display
			var flexibleString = flexVal && flexVal > 0 ? " +/- " + flexVal : "";
				var dpLang = 'en'; // Use English for consistency
				if ($.fn.datepicker && $.fn.datepicker.dates && $.fn.datepicker.dates[selectedLanguage]) {
					dpLang = selectedLanguage;
				}
			var formattedDate = $.fn.datepicker.DPGlobal.formatDate(arrivalDate, 'd M yyyy', dpLang) + flexibleString;
			$('.js-desktop-search-input-arrival, .js-mobile-search-input-arrival').val(formattedDate);

			if ($(window).width() >= 768) {
				$('#search__modal-arrival').addClass('hide');
			}

			try { gae('search_hero', 'tp_modal_arrival-link'); } catch(e) {}
			console.log('🎯 [DATE CLICK] Date selected, ready for combined search');
				
				// CRITICAL: Stop all other changeDate handlers from running (prevents redirect)
				event.stopImmediatePropagation();
				event.preventDefault();
				return false;
			}
		});
		
		// Month link clicks (e.g., "November 2024")
		$('.landing-search__accordion-item a[href*="arrival_date"]').off('click.experiment').on('click.experiment', function(e) {
			e.preventDefault();
			var href = $(this).attr('href');
			if (href) {
				// Extract query params from the href
				var qStart = href.indexOf('?');
				if (qStart > -1) {
					var query = href.substring(qStart);
					window.__expSrParamDateQuery = query;
					console.log('🎯 [MONTH LINK] Stored date query from month link:', query);
					
					// Parse the date and update the input
					var arrivalMatch = query.match(/arrival_date=([^&]+)/);
					var flexibleMatch = query.match(/flexible=([^&]+)/);
					if (arrivalMatch && arrivalMatch[1]) {
						var date = new Date(arrivalMatch[1]);
						if (!isNaN(date.getTime()) && $.fn.datepicker && $.fn.datepicker.DPGlobal) {
							var flexible = flexibleMatch ? flexibleMatch[1] : '15';
							var flexibleString = flexible && flexible > 0 ? " +/- " + flexible : "";
							var dpLang = 'en';
							if ($.fn.datepicker && $.fn.datepicker.dates && $.fn.datepicker.dates[selectedLanguage]) {
								dpLang = selectedLanguage;
							}
							var formattedDate = $.fn.datepicker.DPGlobal.formatDate(date, 'd M yyyy', dpLang) + flexibleString;
							$('.js-desktop-search-input-arrival, .js-mobile-search-input-arrival').val(formattedDate);
						}
					}
					
					// Close the modal
					$('#search__modal-arrival').addClass('hide');
					try { gae('search_hero', 'tp_modal_arrival-link'); } catch(e) {}
				}
			}
		});
		
		// Flexible dropdown change
		$('.filter_flexible').off('change.experiment').on('change.experiment', function() {
			// Update the date query if a date is already selected
			if (window.__expSrParamDateQuery) {
				var flexVal = $(this).val() || '0';
				window.__expSrParamDateQuery = updateQueryStringParameter(window.__expSrParamDateQuery, "flexible", flexVal);
				console.log('🎯 [FLEXIBLE CHANGE] Updated date query with new flexible value:', window.__expSrParamDateQuery);
				
				// Update the input display
				var arrivalDate = $('#availability-options .month').first().datepicker('getUTCDate');
				if (arrivalDate && !isNaN(arrivalDate) && $.fn.datepicker && $.fn.datepicker.DPGlobal) {
					var flexibleString = flexVal && flexVal > 0 ? " +/- " + flexVal : "";
					var dpLang = 'en';
					if ($.fn.datepicker && $.fn.datepicker.dates && $.fn.datepicker.dates[selectedLanguage]) {
						dpLang = selectedLanguage;
					}
					var formattedDate = $.fn.datepicker.DPGlobal.formatDate(arrivalDate, 'd M yyyy', dpLang) + flexibleString;
					$('.js-desktop-search-input-arrival, .js-mobile-search-input-arrival').val(formattedDate);
				}
			}
		});
		
		console.log('🎯 [SEARCH_HERO] Landing search experiment handlers initialized');
	}

});

// Levenshtein distance https://en.wikipedia.org/wiki/Levenshtein_distance
function similarity(t, e) { var r = t, n = e; t.length < e.length && (r = e, n = t); var a = r.length; return 0 == a ? 1 : (a - editDistance(r, n)) / parseFloat(a) } function editDistance(t, e) { t = t.toLowerCase(), e = e.toLowerCase(); for (var r = new Array, n = 0; n <= t.length; n++) { for (var a = n, i = 0; i <= e.length; i++)if (0 == n) r[i] = i; else if (i > 0) { var h = r[i - 1]; t.charAt(n - 1) != e.charAt(i - 1) && (h = Math.min(Math.min(h, a), r[i]) + 1), r[i - 1] = a, a = h } n > 0 && (r[e.length] = a) } return r[e.length] }

const searchTool = (() => {
	document.addEventListener('DOMContentLoaded', (event) => {
		const searchResultHeader = document.querySelector('h2.topic-categories__heading');
		const inputText = document.querySelector('[data-modal = "compoundsearch"]');
		const searchText = searchTool.splitSearchUrl();
		if (searchResultHeader && inputText && !!searchText) {
			searchResultHeader.textContent += `"${searchTool.splitSearchUrl()}"`;
			searchTool.freeTextSearchingMode(inputText);
		}
	});

	let inputJustToggled = false;
	let focusFlag = false;

	document.addEventListener('click', (event) => {
		const sr = document.querySelector('[id="search__modal-compoundsearch"]');
	const searchInput = document.getElementById('search-bar-input');

	if (event.target.classList.contains('jumbotron-show-all')) {
		// Experiment: let the experiment handler build and redirect; do not open new tab
		if ($('.landing-search').attr('id') === 'new-landing-search') {
			event.preventDefault();
			event.stopPropagation();
			return;
		}
		let searchText = document.querySelector('.search_for_free_text');
			if (searchText && !!searchText.innerText) {
				event.stopPropagation();
				searchText.click();
			} else {
				window.open(event.target.dataset.genericSearchPageUrl, '_blank').focus();
			}
			return;
		}

		if (event.target.id === 'search-reset-button') {
			searchTool.resetSearchInput();
			return;
		}

		if (event.target.id === 'date-reset-button') {
			searchTool.resetDateInput();
			return;
		}

		if (event.target.id === 'search-bar-input') {
			if (inputJustToggled || (focusFlag && searchInput.value)) {
				focusFlag = false;
				event.stopPropagation();
				return;
			}

		if (sr && sr.classList.contains('hide')) {
			sr.classList.remove('hide');
		} else if (sr) {
			sr.classList.add('hide');
		}

			inputJustToggled = true;
			event.stopPropagation();

			setTimeout(() => {
				inputJustToggled = false;
			}, 300);
			return;
		}

		if (!event.target.closest('#search-bar-input') && !event.target.closest('[id="search__modal-compoundsearch"]')) {
			if (sr && !sr.classList.contains('hide')) {
				sr.classList.add('hide');
			}
		}
	});

	function isDesktop() {
		return window.innerWidth > 768;
	}

	const searchInput = document.getElementById('search-bar-input');
	if (searchInput && isDesktop()) {
		searchInput.addEventListener('focus', () => {

			if (searchInput.value) {
				focusFlag = true;
			}
		});

		searchInput.addEventListener('blur', (event) => {
			const sr = document.querySelector('[id="search__modal-compoundsearch"]');

			setTimeout(() => {
				if (sr && !event.relatedTarget?.closest('[id="search__modal-compoundsearch"]')) {
					sr.classList.add('hide');
				}
			}, 150);
		});
	}


	// Extracts the exact param key from a raw "key=value" (optionally "?key=value") query segment.
	function paramKey(segment) {
		return segment.replace(/^\?/, '').split('=')[0];
	}

	return {
		searchFreeText: (genericSearchPageUrl = 'sr') => {
			const inputText = document.querySelector('[data-modal = "compoundsearch"]').value;
			let searchUrl = searchTool.parseSearchText(inputText, ' ');
			let urlArray = window.location.search.split('&');
			let index = urlArray.findIndex(f => paramKey(f) === 'k');
			if (index < 0) {
				if (window.location.search.includes('&')) {
					window.location.search += '&' + searchUrl;
				} else {
					window.location.href = `${genericSearchPageUrl}?` + searchUrl;
				}
			} else {
				urlArray[index] = urlArray[index].includes('?') ? `?${searchUrl}` : searchUrl;
				let url = '';
				urlArray.forEach((filter, i) => {
					url += (i > 0 ? '&' : '') + filter;
				});
				window.location.search = url;
			}
		},

		getSearchUrl: (inputText) => {
			const chars = inputText.split(' ');
			let searchUrl = '?k=';
			chars.forEach((word, i) => {
				searchUrl += word + (i < chars.length - 1 ? '%20' : '');
			});
			return searchUrl;
		},

		splitSearchUrl: () => {
			let urlArray = window.location.search.split('&');
			let index = urlArray.findIndex(f => paramKey(f) === 'k');
			if (index > -1) {
				let key = urlArray[index];
				let i = key.indexOf('=') + 1;
				key = key.substring(i);
				return searchTool.parseSearchText(key, '%20');
			}
			return '';
		},

		freeTextSearchingMode: (inputText) => {
			const resetButton = document.querySelector('.search_reset_button');
			resetButton.classList.remove('hidden');
			inputText.value = searchTool.splitSearchUrl();
		},

		resetSearchInput: () => {
			const inputText = document.querySelector('[data-modal = "compoundsearch"]');
			let urlArray = window.location.search.split('&');
			let filters = urlArray.filter(f => (!!f && !['k', 'd', 'sg', 'act'].includes(paramKey(f))));
			let searchUrl = '';
			filters.forEach((f, i) => {
				searchUrl += i > 0 ? `&${f}` : f;
			});
			inputText.value = '';
			window.location.search = searchUrl;
		},

		resetDateInput: () => {
			let urlArray = window.location.search.split('&');
			let filters = urlArray.filter(f => (!!f && !['arrival_date', 'duration_option', 'flexible'].includes(paramKey(f))));
			let searchUrl = '';
			filters.forEach((f, i) => {
				searchUrl += i > 0 ? `&${f}` : f;
			});
			window.location.search = searchUrl;
		},

		parseSearchText: (text, parsed) => {
			const chars = text.split(parsed);
			const parsing = parsed == '%20' ? ' ' : '%20';
			let search = parsed == '%20' ? '' : 'k=';
			chars.forEach((word, i) => {
				search += word + (i < chars.length - 1 ? parsing : '');
			});
			return search;
		}
	}

	// =====================================================================
	// LANDING SEARCH EXPERIMENT LOGIC (plt_landing_search)
	// =====================================================================
	// This section duplicates the landing page search handlers for /sr pages
	// when the experiment is active
	// =====================================================================
	
	if ($('.landing-search').attr('id') === 'new-landing-search') {
		console.log('🎯 [SEARCH_HERO] Initializing landing search experiment handlers on /sr page');
		
		// Mobile handlers
		if ($(window).width() < 768) {
			$('.search__modal-toggle').on('click touch', function() {
				$('body').attr('data-pos', $(window).scrollTop());
				$('body,html').addClass('noscroll');
				$('input').blur();
				$('#search__modal-'+$(this).attr('data-modal')).removeClass('hide');
				$('#search__modal-'+$(this).attr('data-modal')).find('input').focus();
				
				var modalId = $(this).attr('data-modal');
				var evt = null;
				if (modalId === 'arrival') { evt = 'tp_modal_arrival-open'; }
				else if (modalId === 'categories' || modalId === 'activity') { evt = 'tp_modal_activity-open'; }
				else if (modalId === 'compoundsearch') { evt = 'tp_modal_destination-open'; }
				if (evt) { try { gae('search_hero', evt); } catch(e) {} }
				
				return false;
			});
		} else {
			// Desktop handlers
			
		// Opens modals on focus instead of click
		$('.search__modal-toggle').on('focus', function() {
			var modalId = $(this).attr('data-modal');
			var isCategoryInput = $(this).hasClass('js-desktop-search-input-categories') || $(this).hasClass('js-mobile-search-input-categories');
			
			console.log('🎯 [EARLY FOCUS HANDLER] Focus on:', {
				modalId: modalId,
				isCategoryInput: isCategoryInput,
				hasValue: !!$(this).val(),
				categoryModalOpen: !$('#search__modal-categories').hasClass('hide')
			});
			
			// Skip if this is a category input (handled by experiment handler)
			if (isCategoryInput && $('.landing-search').attr('id') === 'new-landing-search') {
				console.log('🎯 [EARLY FOCUS HANDLER] Skipping category input');
				return false;
			}
			
			// Skip if category modal is already open (don't steal focus)
			if (!$('#search__modal-categories').hasClass('hide')) {
				console.log('🎯 [EARLY FOCUS HANDLER] Category modal is open, not switching modals');
				$(this).blur();
				return false;
			}
			
			$('.search__modal').addClass('hide');
			if($(this).val()){
				$('#search__modal-'+modalId).removeClass('hide');
				
				var evt = null;
				if (modalId === 'arrival') { evt = 'tp_modal_arrival-open'; }
				else if (modalId === 'categories' || modalId === 'activity') { evt = 'tp_modal_activity-open'; }
				else if (modalId === 'compoundsearch') { evt = 'tp_modal_destination-open'; }
				if (evt) { try { gae('search_hero', evt); } catch(e) {} }
			}
		});
			
			// Hides the modal when clicking outside
		$('body').on('click touch', function(e){
			console.log('🎯 [BODY CLICK 2] Duplicate body handler fired:', {
				target: e.target.className,
				isFlexible: e.target.classList.contains('landing-filter_flexible'),
				isAccordion: e.target.classList.contains('landing-search__accordion-toggle'),
				isToggle: $(e.target).hasClass('search__modal-toggle'),
				parentsSearchWrapper: $(e.target).parents('.search__wrapper').length
			});
			
			if(e.target.classList.contains('landing-filter_flexible') || e.target.classList.contains('landing-search__accordion-toggle')) {
				console.log('🎯 [BODY CLICK 2] Skipping flexible/accordion');
				return;
			}
			// Don't blur if clicking on a modal toggle input itself
			if ($(e.target).hasClass('search__modal-toggle') || $(e.target).hasClass('js-search__modal-toggle')) {
				console.log('🎯 [BODY CLICK 2] Clicked modal toggle, not closing');
				return;
			}
			if ( $(e.target).parents('.search__wrapper').length == 0 ) {
				console.log('🎯 [BODY CLICK 2] Clicked outside modal, closing all modals');
				$('.search__modal').addClass('hide');
				$('.search__modal-toggle').blur();
			} else {
				console.log('🎯 [BODY CLICK 2] Clicked inside search wrapper, not closing');
			}
		});
		}
		
		console.log('🎯 [SEARCH_HERO] Landing search experiment handlers initialized');
	}

})()